// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T20:29:04.959Z
// Property: The Murray (ID: 5690269169090560)
// Collections: 17 amenities, 4 floorplans (live), 21 photos, 80 POIs, 4 reviews, 3 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5690269169090560",
  "property_external_id": "5056166",
  "property_zillow_url": "https://www.zillow.com/b/residences-at-braemar-charlotte-nc-5XhwJh/",
  "property_apartments_url": "https://www.apartments.com/the-murray-charlotte-nc/j2gee76",
  "property_google_business_url": "https://www.google.com/maps/place/The+Murray/data=!4m2!3m1!1s0x0:0xad81724846be87f4?sa=X&ved=2ahUKEwi-worC07ySAxV0jokEHXz7OWUQ_BJ6BAgWEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "9835263912",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-murray",
  "property_name": "The Murray",
  "property_website_url": "https://www.liveatthemurray.com/",
  "property_domain": "https://www.liveatthemurray.com/",
  "property_address": "8010 Woodsedge Dr",
  "property_full_address": "8010 Woodsedge Dr, Charlotte, NC 28216",
  "property_address_1": "8010 Woodsedge Dr",
  "property_address_2": null,
  "property_address_city": "Charlotte",
  "property_address_state": "NC",
  "property_address_zip_full": "28216-1847",
  "property_address_zip": "28216",
  "property_address_country": "US",
  "property_address_county": "Mecklenburg County",
  "property_neighborhood_address": "Wedgewood",
  "property_address_latitude": "35.3470325",
  "property_address_longitude": "-80.8641971",
  "property_email": "murray@alapts.com",
  "property_phone": "(704) 399-1159",
  "property_call_tracking_phone": "980-291-7238",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Connected Northlake living with room to settle in.</strong> The Murray pairs spacious two- and three-bedroom layouts with polished finishes, smart home features, and easy-access community comforts in a Charlotte location built for streamlined everyday living.</p>",
  "property_long_description": "<p><strong>Connected Northlake living with room to settle in.</strong> At The Murray, you’re positioned across from Northlake Mall with quick access to I-77, I-485, Uptown Charlotte, Huntersville, and the Lake Norman corridor. Daily errands, casual dining, AMC movie nights, and Northlake-area restaurants like Firebirds Wood Fired Grill and Showmars are close by, while Hornets Nest Park and Latta Nature Preserve add easy options for trails, water views, disc golf, and open-air downtime.</p><p>Choose from spacious two- and three-bedroom <a href=\"/floor-plans\">apartment layouts</a> designed for everyday ease, with smart home technology, private patios or balconies, custom walk-in closets, washer and dryer connections, and renovated finishes like stainless steel appliances, white quartz countertops, subway tile backsplashes, and shaker-style cabinetry. Around the community, <a href=\"/amenities\">resort-inspired amenities</a> keep life simple: a swimming pool with expansive sundeck seating, outdoor grilling, a 24-hour fitness center, EV charging stations, package lockers, valet trash service, and a pet park. It’s a polished Charlotte address with the access, comfort, and neighborhood convenience to make every day feel streamlined.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019d02f1-1bdc-75d8-95c9-0fe61af74268.webp",
  "property_featured_image_media": {
    "alt_text": "Living room with a brown leather couch, coffee table, TV, and dining area.",
    "public_id": "019d02f1-1bdc-75d8-95c9-0fe61af74268",
    "storage_key": "property/5690269169090560/019d02f1-1bdc-75d8-95c9-0fe61af74268.webp",
    "width": 1240,
    "height": 826
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "160",
  "property_year_built": "2004",
  "property_year_renovated": "2022",
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "93.75",
  "property_admin_fee": "150",
  "property_application_fee": "50",
  "property_fees_deposit_info": "Application Fee $50\nAdministrative Fee $150\nNon-Refundable Pet Fee $400 for 1st pet, Additional $150 for 2nd pet\nMonthly Pet Rent $30 / pet\nApplication Approval Fee Starting At $399\n",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "400",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $400 for your 1st pet and an additional $150 for your 2nd pet, with a monthly pet rent of $30 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $400 for your 1st pet and an additional $150 for your 2nd pet, with a monthly pet rent of $30 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://themurray.onlineleasing.realpage.com/",
  "property_resident_portal_url": "https://themurray.loftliving.com/login",
  "property_apply_now_url": "https://themurray.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019e73f4-0486-749d-ba89-7e1ea49e1b97.webp",
  "property_primary_logo_media": {
    "alt_text": "The Murray logo",
    "public_id": "019e73f4-0486-749d-ba89-7e1ea49e1b97",
    "storage_key": "property/5690269169090560/019e73f4-0486-749d-ba89-7e1ea49e1b97.webp",
    "width": 3072,
    "height": 3072
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019d02f1-0eff-73e2-ab5d-32c845277dd5.webp",
  "property_secondary_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02f1-0eff-73e2-ab5d-32c845277dd5",
    "storage_key": "property/5690269169090560/019d02f1-0eff-73e2-ab5d-32c845277dd5.webp",
    "width": 325,
    "height": 147
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019e73f4-0364-732e-b47a-d74ab151fc45.webp",
  "property_icon_media": {
    "alt_text": "Green circle with a white stylized 'M' inside.",
    "public_id": "019e73f4-0364-732e-b47a-d74ab151fc45",
    "storage_key": "property/5690269169090560/019e73f4-0364-732e-b47a-d74ab151fc45.webp",
    "width": 2380,
    "height": 2380
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019e73f4-0364-732e-b47a-d74ab151fc45.webp",
  "property_fav_icon_media": {
    "alt_text": "Green circle with a white stylized 'M' inside.",
    "public_id": "019e73f4-0364-732e-b47a-d74ab151fc45",
    "storage_key": "property/5690269169090560/019e73f4-0364-732e-b47a-d74ab151fc45.webp",
    "width": 2380,
    "height": 2380
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019e73f4-06de-7655-a854-2a621bcab082.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Murray logo in white script font on a black background.",
    "public_id": "019e73f4-06de-7655-a854-2a621bcab082",
    "storage_key": "property/5690269169090560/019e73f4-06de-7655-a854-2a621bcab082.webp",
    "width": 3072,
    "height": 3072
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019e73f4-05bf-760f-9094-6c3d28c1b227.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Murray property logo",
    "public_id": "019e73f4-05bf-760f-9094-6c3d28c1b227",
    "storage_key": "property/5690269169090560/019e73f4-05bf-760f-9094-6c3d28c1b227.webp",
    "width": 3072,
    "height": 3072
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#41693d",
  "property_secondary_color": "#808285",
  "property_font_color": "#2e2a25",
  "property_color_4": null,
  "property_color_3": "#000000",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "2 - 3",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "2",
  "property_bathrooms_min": "2",
  "property_bathrooms_max": "2",
  "property_sqft_range": "991 - 1113",
  "property_sqft_min": "991",
  "property_sqft_max": "1113",
  "property_price_range": "1611 - 1779",
  "property_price_min": "1611",
  "property_price_max": "1779",
  "property_available_units": 10,
  "property_facebook_url": "https://www.facebook.com/TheMurrayApartments",
  "property_instagram_url": "https://www.instagram.com/themurrayapts",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJFaiE6vmmVogR9Ie-Rkhyga0",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/residences-at-braemar-apartment-charlotte",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Polished convenience, inside and out.</strong> At The Murray, daily routines get a clean upgrade with a 24-hour fitness center, pool with an expansive sundeck, outdoor grilling area, EV charging, parcel lockers, valet trash, and 24/7 online resident tools. Inside, smart home technology, stainless appliances, white quartz counters, subway tile backsplashes, shaker-style cabinetry, custom walk-in closets, and private patios or balconies bring modern ease home.</p>",
  "property_home_floorplans_blurb": "<p><strong>Two- and three-bedroom layouts with room to breathe.</strong> At The Murray, each Northlake apartment pairs two baths with open living space, breakfast bars, custom walk-in closets, and a private patio or balcony. Select finishes add a crisp, current feel, from stainless appliances and built-in microwaves to white quartz counters, subway tile backsplashes, shaker-style cabinetry, two-inch blinds, and smart home technology.</p>",
  "property_home_gallery_blurb": "<p><strong>See The Murray in its best light.</strong> Browse bright kitchens with white quartz counters and subway tile, open living areas, and patios or balconies made for an easy indoor-outdoor feel. Then picture the pool, expansive sundeck, grilling area, clubhouse, fitness center, and pet-friendly green space—all set against relaxed Northlake surroundings.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Northlake puts the day’s essentials close.</strong> From The Murray, reach Northlake Mall, AMC Northlake 14, Target, Sticks and Beans, and Center Lake Drive dining with ease. I-77, I-485, and Harris Boulevard keep Uptown Charlotte, Huntersville, and Lake Norman connected, while Hornets Nest Park and Latta Nature Preserve add trails, disc golf, wooded paths, and lake views to the map.</p>",
  "property_home_reviews_blurb": "<p><strong>Resident reviews point to an easy, well-supported experience.</strong> Feedback for The Murray highlights a nice, attentive leasing team, smooth move-ins, and prompt follow-up when questions arise. Residents also mention quick maintenance, clean apartment homes at move-in, smart-home controls for locks, thermostats, and lights, plus conveniences like valet trash. Read more to see why helpful service and practical comforts stand out here.</p>",
  "property_neighborhood_blurb": "<p><strong>Northlake keeps your day within easy reach.</strong> From The Murray, you’re close to the retail-and-restaurant hub around Northlake Mall, where AMC Northlake 14, Target runs, coffee at Sticks and Beans, and dinner spots along Center Lake Drive make everyday plans simple. I-77, I-485, and Harris Boulevard put Uptown Charlotte, Huntersville, and the Lake Norman corridor in play, while CATS Route 7 connects the area with the Charlotte Transportation Center. When you want more green than pavement, head to Hornets Nest Park for trails and disc golf, or make the short drive to Latta Nature Preserve for wooded paths and Mountain Island Lake views. Explore the map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how this Northlake location fits your routine.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Everyday ease, polished from curb to kitchen.</strong> At The Murray, amenities do more than look good in photos—they help your routine run smoother. Recharge at the 24-hour fitness center, stretch out by the pool’s expansive sundeck, fire up the outdoor grilling area, or take advantage of thoughtful conveniences like EV charging, parcel lockers, valet trash, Spruce services, RentPlus credit building, and 24/7 online resident tools.</p><p>Inside, your apartment keeps the same clean, modern rhythm with smart home technology, stainless appliances, white quartz counters, subway tile backsplashes, shaker-style cabinetry, custom walk-in closets, and a private patio or balcony. Browse the <a href=\"/gallery\">photo gallery</a> to see the details, then <a href=\"/schedule-a-tour\">schedule a tour</a> to experience The Murray’s Northlake amenities in person.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make The Murray home?</strong> Choose a spacious two- or three-bedroom layout with everyday comforts like smart home technology, walk-in closets, private outdoor space, and renovated finishes. Start your application online today and take the next step toward connected Charlotte living with room to settle in.</p>",
  "property_contactus_blurb": "<p><strong>Have questions about The Murray?</strong> Our leasing team is here to help with apartment details, availability, tour options, and directions to our connected Northlake location. Reach out today and get the information you need to take the next step.</p>",
  "property_faqs_blurb": "<p><strong>Questions about The Murray?</strong> Start here for quick answers about the community, leasing, apartment features, amenities, and day-to-day living. If you need more details or want help finding the right next step, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Compare layouts with everyday flow in mind.</strong> The Murray’s two- and three-bedroom apartments in Northlake give you more than a room count—each plan pairs two baths with open living areas, breakfast bars, custom walk-in closets, and a private patio or balcony for a little breathing room.</p><p>As you browse availability, look for the finishes that make each home feel crisp and current: stainless appliances with built-in microwaves, white quartz counters, subway tile backsplashes, shaker-style cabinetry, two-inch blinds, and smart home technology. Want to see how the details come together? View the <a href=\"/gallery\">photo gallery</a>, explore more <a href=\"/amenities\">apartment features</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to walk your favorite floor plan.</p>",
  "property_gallery_blurb": "<p><strong>Start with the light.</strong> The Murray’s photo gallery lets you zoom in on the finishes, views, and shared spaces that shape the community’s everyday look—from bright kitchens with white quartz counters and subway tile to open living areas that extend toward a private patio or balcony.</p><p>Scroll from the pool and expansive sundeck to the grilling area, clubhouse, fitness center, and pet-friendly green space, then compare how each scene fits your routine. You’ll see clean lines, smart details, and relaxed Northlake surroundings without having to imagine them from a list. When a photo catches your eye, explore more <a href=\"/amenities\">amenities and finishes</a>, browse <a href=\"/floor-plans\">available layouts</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see The Murray in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore The Murray on the map.</strong> See available apartments alongside the Northlake-area conveniences that keep Charlotte connected—from quick I-77 and I-485 access to nearby dining, shopping, parks, and everyday stops.</p>",
  "property_pets_blurb": "<p><strong>Bring the paws, tails, and sunny-window naps.</strong> At The Murray, pet-friendly apartment living in Northlake means cats and dogs are part of the everyday rhythm—not an afterthought. With no weight limit and room for up to two pets per home, your companion can settle into a spacious layout with modern finishes and a private patio or balcony for fresh-air moments.</p><p>Step outside for quick playtime at the on-site <a href=\"/amenities\">pet park</a>, then keep your routine moving with nearby pet essentials, 24/7 resident tools, valet trash, and community spaces made for relaxed days at home. Have questions about breed guidelines or bringing a second pet? <a href=\"/contact-us\">Contact the leasing team</a> for details before you apply.</p>",
  "property_referafriend_blurb": "<p><strong>Share connected Northlake living.</strong> If The Murray’s spacious two- and three-bedroom layouts, polished finishes, and everyday convenience make home feel streamlined, invite a friend to experience it too. Send a referral and help them discover the comfort, access, and ease you already enjoy.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at The Murray.</strong><br>Pay rent, submit maintenance requests, and manage your account online with the same everyday ease that defines life here—from spacious two- and three-bedroom layouts to smart home technology, renovated finishes, and connected Northlake convenience.</p>",
  "property_reviews_blurb": "<p><strong>See what everyday life feels like at The Murray.</strong> In these resident reviews, you’ll find recurring praise for a leasing team described as “nice and attentive,” a simple move-in process, and prompt follow-up when questions or requests come up.</p><p>Residents also call out quick maintenance response times, clean apartment homes at move-in, smart-home controls for locks, thermostats, and lights, plus convenient services like valet trash. The theme is clear: helpful people, responsive service, and practical comforts that make it easy to say, “I would recommend.”</p>",
  "property_created_at": "1752256520445",
  "property_scheduletour_blurb": "<p><strong>See connected Charlotte living up close.</strong> Tour spacious two- and three-bedroom layouts with smart home technology, private outdoor space, walk-in closets, and renovated finishes—then get a feel for the pool, fitness center, pet park, and everyday conveniences that streamline life at The Murray. Schedule your visit today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — your inquiry has been received.</strong><br>The Murray leasing team will be in touch soon. In the meantime, picture connected Northlake living with spacious two- and three-bedroom layouts, smart home touches, renovated finishes, and community spaces designed to keep daily life comfortable and streamlined.</p>",
  "property_virtualtours_blurb": "<p><strong>Tour the details before you decide.</strong> The Murray’s virtual tours let you move through the spaces that matter most, from the community setting to spacious 2BR, 2BA and 3BR, 2BA apartment layouts. Step inside to see how open living areas, bright windows, breakfast bars, walk-in closets, private outdoor space, and clean modern finishes come together in real time.</p><p>Start with the Community tour for a feel of the poolside sundeck, clubhouse, fitness spaces, and everyday conveniences, then compare apartment tours side by side to picture your furniture, routine, and favorite view. When you’re ready for the next step, browse current <a href=\"/floor-plans\">floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience The Murray in Northlake in person.</p>",
  "property_copyright": "2025 All Rights Reserved. The Murray",
  "property_seo_title_home": "The Murray | Apartments in Charlotte, NC",
  "property_seo_description_home": "Discover your dream apartment at The Murray in Charlotte, NC! Choose from spacious two and three-bedroom floor plans designed for your lifestyle. Enjoy top-notch amenities like a fitness center, pool, LUXER package locker, and smart locks, plus beautiful finishes including tile backsplashes and hardwood floors. With options for every need, including handicap accessibility and stunning wooded or pool views, you’ll find your perfect home in our vibrant community. Explore all that The Murray has to offer—find your new home today!",
  "property_seo_title_floorplans": "Floor Plans | 2 - 3 Apartments in Charlotte, NC",
  "property_seo_description_floorplans": "Discover your ideal living space at The Murray in Charlotte, NC! Explore our thoughtfully designed floor plans featuring spacious two-bedroom and three-bedroom apartments. Browse our available apartment homes today and find the perfect layout that suits your lifestyle. Your dream home awaits!",
  "property_seo_title_amenities": "Amenities | Charlotte, NC Apartments for Rent",
  "property_seo_description_amenities": "Discover your ideal living space at The Murray in Charlotte, NC! Choose from our spacious two and three-bedroom floor plans featuring modern finishes and stunning wooded or pool views. Enjoy top-notch amenities including a state-of-the-art fitness center, relaxing grill area, and luxurious pool. With smart locks, LUXER package lockers, and online resident services, convenience is just an inch away. Explore our amazing community amenities and apartment features today!",
  "property_seo_title_gallery": "Gallery | Apartments in Charlotte, NC",
  "property_seo_description_gallery": "Discover your dream home at The Murray in Charlotte, NC! Explore our spacious two and three-bedroom floor plans, complemented by exceptional amenities including a state-of-the-art fitness center, luxurious pool, and outdoor grill area. With modern kitchens, smart locks, and online resident services, every detail is designed for comfort and convenience. Picture yourself living here amidst beautiful wooded views and stylish interiors. Don’t miss out—view our photo gallery and envision your new life today!",
  "property_seo_title_virtualtours": "Virtual Tours | The Murray Apartments",
  "property_seo_description_virtualtours": "Explore The Murray in Charlotte, NC! Discover our spacious two and three-bedroom floor plans, designed for modern living. Take a virtual tour of our exceptional community and find your perfect apartment today! Don’t miss out—explore now!",
  "property_seo_title_interactivemap": "Interactive Map | The Murray Apartments",
  "property_seo_description_interactivemap": "Discover your dream home at The Murray in Charlotte, NC! Explore our spacious two and three-bedroom floor plans featuring luxurious amenities like a state-of-the-art fitness center, pool, LUXER Package Locker, and online resident services. Enjoy stylish interiors with tall ceilings, wood floors, and modern kitchen appliances, plus stunning views from select units. Use our interactive community map to find available apartments, view pricing, and start your new adventure today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Charlotte, NC",
  "property_seo_description_neighborhood": "Discover the vibrant neighborhood surrounding The Murray in Charlotte, NC! Explore our diverse floor plans, featuring spacious two and three-bedroom apartments, and dive into local favorites and nearby points of interest. See what's around our community and find your perfect home today!",
  "property_seo_title_contact": "Contact Us | The Murray",
  "property_seo_description_contact": "Discover your ideal space at The Murray in Charlotte, NC! Our beautifully designed two and three-bedroom floor plans offer the perfect blend of comfort and style. Explore all our options and find your perfect home. Have questions? Contact our leasing team today for personalized assistance!",
  "property_seo_title_faqs": "FAQs | Apartments in Charlotte, NC",
  "property_seo_description_faqs": "Discover everything you need to know about The Murray in Charlotte, NC! Browse our FAQs page to get answers on our spacious two and three-bedroom floor plans, luxurious amenities like our fitness center, sparkling pool, and smart home features. Learn about our unique offerings, including LUXER package lockers, online resident services, and handicap accessibility. Join our vibrant community today and elevate your living experience with us!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Charlotte, NC",
  "property_seo_description_reviews": "Discover your next home at The Murray in Charlotte, NC! Explore our spacious two and three-bedroom floor plans, designed with modern amenities like smart locks, hardwood floors, and a wet bar. Enjoy top-notch community features, including a fitness center, pool, and grill area, plus convenient online resident services. With options for every preference, including handicap accessibility and stunning wooded views, you’ll find the perfect fit. Curious about life at The Murray? See what our residents have to say about living in our vibrant community!",
  "property_seo_title_applynow": "Apply Now | Apartments in Charlotte, NC",
  "property_seo_description_applynow": "Discover your ideal living space at The Murray in Charlotte, NC! Choose from our spacious two and three-bedroom floor plans featuring modern amenities like smart locks, luxury package lockers, and a state-of-the-art fitness center. Enjoy relaxing by the pool, grilling in our outdoor area, or utilizing our convenient online resident services. With hardwood floors, tall ceilings, and beautiful tile backsplashes, your new home awaits. Apply now and find your perfect apartment today!",
  "property_seo_title_residentaccess": "Resident Access | The Murray",
  "property_seo_description_residentaccess": "\"Welcome to The Murray in Charlotte, NC! Access your resident portal for easy rent payments, maintenance scheduling, and exclusive community updates. Enjoy hassle-free living—log in now!\"",
  "property_seo_title_referafriend": "Refer A Friend | The Murray",
  "property_seo_description_referafriend": "\"Discover vibrant living at The Murray in Charlotte, NC! Refer a friend today and enjoy exclusive rewards in our welcoming apartment community. Great friends make great neighbors—let's grow our community together!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | The Murray",
  "property_seo_description_scheduletour": "Discover your dream home at The Murray in vibrant Charlotte, NC! Schedule a tour today to explore our modern amenities, spacious floor plans, and welcoming community. Don’t miss out—step into your new lifestyle!",
  "property_seo_title_privacy": "Privacy Policy | The Murray",
  "property_seo_description_privacy": "Discover how The Murray in Charlotte, NC, protects your personal information with our comprehensive privacy policy. Your trust is our priority! 🏡✨ View our privacy policy to learn more about our commitment to your privacy.",
  "property_seo_title_accessibility": "Website Accessibility | The Murray",
  "property_seo_description_accessibility": "\"Discover The Murray in Charlotte, NC, where accessibility meets comfort. Explore our commitment to digital inclusion and how we strive to make every guest feel welcome. Join our community today!\"",
  "property_seo_title_sitemap": "Sitemap | The Murray",
  "property_seo_description_sitemap": "Discover your next home at The Murray in Charlotte, NC! Explore our comprehensive sitemap to easily navigate our community offerings, from stylish apartments to incredible amenities. View our sitemap now for a seamless living experience!",
  "property_seo_title_thankyou": "Thank You | The Murray",
  "property_seo_description_thankyou": "\"Thank you for your submission! At The Murray in Charlotte, NC, we value your interest and look forward to helping you find your perfect home. A member of our dedicated team will reach out to you shortly to answer any questions and provide assistance in your apartment search. Stay tuned for exciting updates from your future community!\"",
  "property_seo_title_pets": "Pet Policy | Apartments in Buford, GA\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793651140038",
  "amenities": [
    {
      "id": "custom_e0ada5d0-4e6c-4872-aa71-cd1220fff0eb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Stainless Steel Appliances",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_73f76325-985e-4252-a69b-0896ac20ee5f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "custom",
      "external_id": "P000000704",
      "title": "W&D Included",
      "amount": "0.0000",
      "description": "Full-Size Washer & Dryer Connection",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d834f545-fabc-4cdb-b4a5-b1dd672d6801",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "custom",
      "external_id": "P000000676",
      "title": "Sink",
      "amount": "0.0000",
      "description": "Undermount Sink w/ Gooseneck Faucet",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d3d80478-2db2-468d-9893-73fd750d3d68",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "custom",
      "external_id": "P000000621",
      "title": "Counters",
      "amount": "0.0000",
      "description": "Quartz Countertops",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4c909a64-445e-4945-a3cf-0983904b8ce6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "custom",
      "external_id": "P000000663",
      "title": "Outside Space",
      "amount": "0.0000",
      "description": "Private Patios and Balconies",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f34c6f77-28ba-4aa1-96e6-4dca9a6b2be9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "custom",
      "external_id": "P000000707",
      "title": "Wet Bar",
      "amount": "0.0000",
      "description": "Breakfast Bar",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7c6dcefc-f653-4c86-9434-518497c12110",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "custom",
      "external_id": "P000000690",
      "title": "Tall Ceilings",
      "amount": "0.0000",
      "description": "Vaulted Ceilings",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_91cb025b-e24e-4253-958c-8d39b8ad5070",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "custom",
      "external_id": "P000000695",
      "title": "Tile Backsplash",
      "amount": "0.0000",
      "description": "Subway Tile Backsplash",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5fedecac-d329-49e2-a8ef-cd797fe8faff",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "custom",
      "external_id": "P000000603",
      "title": "Blinds",
      "amount": "0.0000",
      "description": "2-Inch Blinds",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_41a41551-33e7-4412-ab9a-097079435297",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "custom",
      "external_id": "P000000609",
      "title": "Cabinets",
      "amount": "0.0000",
      "description": "White Cabinetry",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b0d43954-3392-4e73-9c48-755836604572",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "custom",
      "external_id": "P000000646",
      "title": "Hard Floors",
      "amount": "0.0000",
      "description": "Plank Style Flooring",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5ccfda5e-c71b-47b7-b6f0-e1b369e2363c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "custom",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "Resort-Style Swimming Pool w/ Sundeck",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a6d2baa6-c907-4113-9e93-4cf251420849",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "custom",
      "external_id": "P000000145",
      "title": "LUXER Package Locker",
      "amount": "0.0000",
      "description": "Parcel Pending Package Lockers",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d0fba365-12b3-47fd-b9ea-bc29cd273483",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "24-Hour Fitness Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_20a87965-3079-409b-95fe-a68e20aad9eb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "custom",
      "external_id": "P000000644",
      "title": "Grill Area",
      "amount": "0.0000",
      "description": "Outdoor Grilling Area",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0e9088c6-7533-4ed5-b33a-7320ee9d8df4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0efb2aa9-195a-4d20-aa59-9ef98f5ef33b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_37a03591-0b0b-4b03-ab0d-7ed29be6d85b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019e8a05-0577-71be-8edb-9fde60788d1a.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, stainless steel appliances, and quartz countertops.",
        "public_id": "019e8a05-0577-71be-8edb-9fde60788d1a",
        "storage_key": "property/5690269169090560/019e8a05-0577-71be-8edb-9fde60788d1a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring white cabinetry, stainless steel appliances, and elegant quartz countertops, perfect for preparing meals.",
      "link": "",
      "alt_text": "Kitchen with white cabinets, stainless steel appliances, and quartz countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_02541de3-dd55-4ecd-b853-726c3443c88e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019e8a04-f78d-727c-959f-3e5ec2492ca1.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
        "public_id": "019e8a04-f78d-727c-959f-3e5ec2492ca1",
        "storage_key": "property/5690269169090560/019e8a04-f78d-727c-959f-3e5ec2492ca1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and umbrellas for ultimate relaxation.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f0e54489-02cf-4552-a404-5f9dca580e34",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019e8a04-f38d-774c-a806-179a9b7a6856.webp",
      "image_media": {
        "alt_text": "Modern living room with leather couch, coffee table, TV stand, and dining area.",
        "public_id": "019e8a04-f38d-774c-a806-179a9b7a6856",
        "storage_key": "property/5690269169090560/019e8a04-f38d-774c-a806-179a9b7a6856.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable leather sofa, a round wooden coffee table with decorative items, and a sleek TV stand. The adjacent dining area adds to the open-concept feel.",
      "link": "",
      "alt_text": "Modern living room with leather couch, coffee table, TV stand, and dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6c531df8-3b7e-4d56-912b-90758faf33d0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019e8a04-f596-70ce-9a75-66fb178ed187.webp",
      "image_media": {
        "alt_text": "Community lounge with plush sofas, coffee table, and dining tables.",
        "public_id": "019e8a04-f596-70ce-9a75-66fb178ed187",
        "storage_key": "property/5690269169090560/019e8a04-f596-70ce-9a75-66fb178ed187.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and socialize in our inviting community lounge, featuring comfortable seating, a large TV, and ample space for work or dining.",
      "link": "",
      "alt_text": "Community lounge with plush sofas, coffee table, and dining tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_47c416e6-0665-4b03-899b-f21da43bf339",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019e8a04-f746-7258-9ebf-4cf57c3bfe8a.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, and shower.",
        "public_id": "019e8a04-f746-7258-9ebf-4cf57c3bfe8a",
        "storage_key": "property/5690269169090560/019e8a04-f746-7258-9ebf-4cf57c3bfe8a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A stylish and modern bathroom featuring a spacious vanity with a sleek faucet, a clean toilet, and a relaxing shower area. Perfect for your daily routine.",
      "link": "",
      "alt_text": "Modern bathroom with vanity, toilet, and shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8e8064bb-93cb-470e-8ef7-81a64a27b06b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019e8a04-eef0-747e-9299-ac4a1c95bbda.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, stationary bikes, yoga mats, medicine balls, and resistance bands.",
        "public_id": "019e8a04-eef0-747e-9299-ac4a1c95bbda",
        "storage_key": "property/5690269169090560/019e8a04-eef0-747e-9299-ac4a1c95bbda.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio equipment, free weights, and functional training accessories for a complete workout.",
      "link": "",
      "alt_text": "Fitness center with treadmills, stationary bikes, yoga mats, medicine balls, and resistance bands.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5d464166-5eb7-4ab1-9bdc-dd0f2abae8e2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019e8a04-ef39-760d-91ed-f9c1bbafbd0a.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a king-size bed, orange comforter, and green accent wall.",
        "public_id": "019e8a04-ef39-760d-91ed-f9c1bbafbd0a",
        "storage_key": "property/5690269169090560/019e8a04-ef39-760d-91ed-f9c1bbafbd0a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience comfort in this inviting bedroom featuring a stylish king-size bed, vibrant orange bedding, and a striking green accent wall.",
      "link": "",
      "alt_text": "Cozy bedroom with a king-size bed, orange comforter, and green accent wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_57c5118c-c8e6-4b31-8b0d-065b48ba88c4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019e8a04-f0f5-71fd-8600-b487605e4f86.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with white siding, black trim, and balconies on a sunny day.",
        "public_id": "019e8a04-f0f5-71fd-8600-b487605e4f86",
        "storage_key": "property/5690269169090560/019e8a04-f0f5-71fd-8600-b487605e4f86.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Community",
      "description": "Beautifully maintained apartment building exterior surrounded by lush green lawns and mature trees. Offers a welcoming and serene living environment.",
      "link": "",
      "alt_text": "Exterior view of apartment building with white siding, black trim, and balconies on a sunny day.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8cb11cfd-0dd0-4d91-9bf2-4984e8a20228",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019e8a04-ec6a-7632-8e39-c3a8556a974d.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "019e8a04-ec6a-7632-8e39-c3a8556a974d",
        "storage_key": "property/5690269169090560/019e8a04-ec6a-7632-8e39-c3a8556a974d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, surrounded by comfortable lounge chairs and lush landscaping. The perfect oasis for a sunny afternoon.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3aaa9d38-cfd3-42f9-b4ab-0c548a159f4a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019e8a04-ece2-725a-ac70-c1a487119b10.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a large island.",
        "public_id": "019e8a04-ece2-725a-ac70-c1a487119b10",
        "storage_key": "property/5690269169090560/019e8a04-ece2-725a-ac70-c1a487119b10.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This spacious kitchen features ample cabinet space, a sleek countertop, and modern appliances, perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a large island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c6ff0d3f-80b5-4477-ad35-c814aef27bd8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019e8a04-eb7b-751d-ab85-3035513f9b07.webp",
      "image_media": {
        "alt_text": "Living room with a brown leather sofa, coffee table, and sliding glass doors.",
        "public_id": "019e8a04-eb7b-751d-ab85-3035513f9b07",
        "storage_key": "property/5690269169090560/019e8a04-eb7b-751d-ab85-3035513f9b07.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a stylish brown leather sofa, a wooden coffee table, and ample natural light from sliding glass doors.",
      "link": "",
      "alt_text": "Living room with a brown leather sofa, coffee table, and sliding glass doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a11ec59d-fb47-453b-b20b-70be2fa80984",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019e8a04-d302-73bf-9f8e-72fab3947e25.webp",
      "image_media": {
        "alt_text": "Sparkling outdoor swimming pool with lounge chairs and a clubhouse.",
        "public_id": "019e8a04-d302-73bf-9f8e-72fab3947e25",
        "storage_key": "property/5690269169090560/019e8a04-d302-73bf-9f8e-72fab3947e25.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our beautiful outdoor swimming pool, perfect for relaxing and soaking up the sun. The surrounding lounge chairs and clubhouse offer additional comfort and convenience.",
      "link": "",
      "alt_text": "Sparkling outdoor swimming pool with lounge chairs and a clubhouse.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a4626f32-0c2b-4455-953c-f454e14a5001",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019e8a04-d42f-70ad-acdc-05a880873556.webp",
      "image_media": {
        "alt_text": "A children's playground with a slide and climbing structure in a fenced-in grassy area.",
        "public_id": "019e8a04-d42f-70ad-acdc-05a880873556",
        "storage_key": "property/5690269169090560/019e8a04-d42f-70ad-acdc-05a880873556.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, perfect for children to play and explore.",
      "link": "",
      "alt_text": "A children's playground with a slide and climbing structure in a fenced-in grassy area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bf8b1f4b-17ff-45f2-8878-7fa5009621aa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019e8a04-d3ce-745d-a0d2-c572309984ff.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with parking lots and green spaces.",
        "public_id": "019e8a04-d3ce-745d-a0d2-c572309984ff",
        "storage_key": "property/5690269169090560/019e8a04-d3ce-745d-a0d2-c572309984ff.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Community",
      "description": "Explore our vibrant community with ample parking and lush green spaces, creating a comfortable and convenient living environment.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings with parking lots and green spaces.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a4f2ef3b-c89e-42c0-abb1-f1f2be6832e6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019e8a04-d410-7529-8754-1c877c879623.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dining area, featuring a breakfast bar, stainless steel appliances, and a round dining table with chairs.",
        "public_id": "019e8a04-d410-7529-8754-1c877c879623",
        "storage_key": "property/5690269169090560/019e8a04-d410-7529-8754-1c877c879623.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy meals and entertain guests in this stylish kitchen and dining area, complete with a breakfast bar, sleek cabinetry, and a comfortable dining set.",
      "link": "",
      "alt_text": "Modern kitchen with dining area, featuring a breakfast bar, stainless steel appliances, and a round dining table with chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ac31b447-c5ca-41a2-9c50-3cac8f7712cf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019e8a04-d4b7-73bc-859e-7789d1d75f4e.webp",
      "image_media": {
        "alt_text": "Green grass courtyard with a park bench and parking lot with cars in the background.",
        "public_id": "019e8a04-d4b7-73bc-859e-7789d1d75f4e",
        "storage_key": "property/5690269169090560/019e8a04-d4b7-73bc-859e-7789d1d75f4e.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Community",
      "description": "Enjoy ample parking and open green spaces for relaxation and recreation.",
      "link": "",
      "alt_text": "Green grass courtyard with a park bench and parking lot with cars in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e8719e59-b287-431d-8e24-4bff230c16ff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019e8a04-d409-72eb-8b9c-00b800b106a7.webp",
      "image_media": {
        "alt_text": "Electric vehicle charging stations in the parking lot.",
        "public_id": "019e8a04-d409-72eb-8b9c-00b800b106a7",
        "storage_key": "property/5690269169090560/019e8a04-d409-72eb-8b9c-00b800b106a7.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Community",
      "description": "Convenient electric vehicle charging stations available for residents. Stay powered up and on the go with our eco-friendly amenities.",
      "link": "",
      "alt_text": "Electric vehicle charging stations in the parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_05b64170-c009-47dd-90bc-017b58900478",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019e8a04-d223-73be-96e2-b76c8b0e1414.webp",
      "image_media": {
        "alt_text": "A well-equipped fitness center with stationary bikes, a cable machine, and weight machines.",
        "public_id": "019e8a04-d223-73be-96e2-b76c8b0e1414",
        "storage_key": "property/5690269169090560/019e8a04-d223-73be-96e2-b76c8b0e1414.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring cardio machines, weight training equipment, and more.",
      "link": "",
      "alt_text": "A well-equipped fitness center with stationary bikes, a cable machine, and weight machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d7ea6acf-9023-4543-b9d4-39c312addcf8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019e8a04-d2c8-7644-b012-22ab73cc2203.webp",
      "image_media": {
        "alt_text": "Stylish living room with two couches, coffee table, fireplace, and TV.",
        "public_id": "019e8a04-d2c8-7644-b012-22ab73cc2203",
        "storage_key": "property/5690269169090560/019e8a04-d2c8-7644-b012-22ab73cc2203.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in this beautifully appointed community living room, featuring comfortable seating and a cozy fireplace.",
      "link": "",
      "alt_text": "Stylish living room with two couches, coffee table, fireplace, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5f303007-6fcc-49de-8bcb-7d5080d76995",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019e8a04-d2c7-7434-bd62-ccdf55c4b03b.webp",
      "image_media": {
        "alt_text": "Bedroom with a twin bed, dresser, and decorative wall art.",
        "public_id": "019e8a04-d2c7-7434-bd62-ccdf55c4b03b",
        "storage_key": "property/5690269169090560/019e8a04-d2c7-7434-bd62-ccdf55c4b03b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a twin bed with stylish bedding, a modern dresser, and unique woven wall decor.",
      "link": "",
      "alt_text": "Bedroom with a twin bed, dresser, and decorative wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_90fa14f8-1671-4469-af91-f506b0b39679",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019e8a04-d2bf-7149-a9b4-0637f941a15e.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a double vanity, large mirror, shower, and toilet.",
        "public_id": "019e8a04-d2bf-7149-a9b4-0637f941a15e",
        "storage_key": "property/5690269169090560/019e8a04-d2bf-7149-a9b4-0637f941a15e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy the modern comforts of this well-appointed bathroom, featuring a spacious vanity, elegant fixtures, and a refreshing shower.",
      "link": "",
      "alt_text": "Modern bathroom with a double vanity, large mirror, shower, and toilet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_44dae4a62bbb11701af0d109",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Mean Mug Coffee Company",
      "poi_type": "Restaurants",
      "poi_address": "Northlake Mall Dr, Charlotte, NC 28216, USA",
      "poi_short_description": "Laid-back coffee shop offering breakfast and quick bites, including sandwiches, muffins, and lattes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14ef-e917-7709-80c7-f9ba2817a791.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-e917-7709-80c7-f9ba2817a791",
        "storage_key": "property/5690269169090560/019f14ef-e917-7709-80c7-f9ba2817a791.webp",
        "width": 828,
        "height": 466
      },
      "poi_business_url": "http://meanmugcoffeeco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14618411943158931032&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mean-mug-coffee-company",
      "poi_latitude": "35.3522957",
      "poi_longitude": "-80.8500174",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 980-565-3589",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-e5a2-718d-9d32-0a22896ae686.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e5a2-718d-9d32-0a22896ae686",
        "storage_key": "property/5690269169090560/019f14f0-e5a2-718d-9d32-0a22896ae686.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJsbjUcSSnVogRWN5Q7DUI38o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_0a11c20a22564f35f4291c20",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Firebirds Wood Fired Grill",
      "poi_type": "Restaurants",
      "poi_address": "6801 Northlake Mall Dr, Charlotte, NC 28216, USA",
      "poi_short_description": "Chain restaurant serving steaks, seafood & cocktails in an upscale lodgelike setting.",
      "poi_long_description": "Chain restaurant serving steaks, seafood & cocktails in an upscale lodgelike setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14ef-eec3-75be-baf6-42f2fd5108bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-eec3-75be-baf6-42f2fd5108bf",
        "storage_key": "property/5690269169090560/019f14ef-eec3-75be-baf6-42f2fd5108bf.webp",
        "width": 1280,
        "height": 847
      },
      "poi_business_url": "https://firebirdsrestaurants.com/charlotte-northlake",
      "poi_directions_map_url": "https://maps.google.com/?cid=16779945163724510867&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "firebirds-wood-fired-grill",
      "poi_latitude": "35.3521893",
      "poi_longitude": "-80.8514732",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-295-1919",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bcb5-724e-82df-df3f03a5fe55.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bcb5-724e-82df-df3f03a5fe55",
        "storage_key": "property/5690269169090560/019f14eb-bcb5-724e-82df-df3f03a5fe55.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnycdKFWmVogRk1ZV8jhX3ug",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_1a1c8d3e8baeac844230de54",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "TGI Fridays",
      "poi_type": "Restaurants",
      "poi_address": "6840 Northlake Mall Dr, Charlotte, NC 28216, USA",
      "poi_short_description": "Casual chain restaurant with a festive vibe serving beer, cocktails & a wide menu of American fare.",
      "poi_long_description": "Casual chain restaurant with a festive vibe serving beer, cocktails & a wide menu of American fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14ef-f255-70e1-8975-1cc3c27b16aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-f255-70e1-8975-1cc3c27b16aa",
        "storage_key": "property/5690269169090560/019f14ef-f255-70e1-8975-1cc3c27b16aa.webp",
        "width": 1080,
        "height": 1080
      },
      "poi_business_url": "https://locations.tgifridays.com/nc/charlotte/6840-northlake-mall-dr.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=5351811441172419308&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tgi-fridays",
      "poi_latitude": "35.3494146",
      "poi_longitude": "-80.85131969999999",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-596-2869",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bcb5-724e-82df-df3f03a5fe55.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bcb5-724e-82df-df3f03a5fe55",
        "storage_key": "property/5690269169090560/019f14eb-bcb5-724e-82df-df3f03a5fe55.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJh9jThQCnVogR7BL0jyZ0RUo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_b96371e303eec2ed90189340",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Showmars Northlake Mall",
      "poi_type": "Restaurants",
      "poi_address": "6801 Northlake Mall Dr, Charlotte, NC 28216, USA",
      "poi_short_description": "Local chain serving gyros, souvlaki & Greek-American fare in a bright, casual setting.",
      "poi_long_description": "Local chain serving gyros, souvlaki & Greek-American fare in a bright, casual setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14ef-eeba-70bf-a6b7-4c73eb30e073.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-eeba-70bf-a6b7-4c73eb30e073",
        "storage_key": "property/5690269169090560/019f14ef-eeba-70bf-a6b7-4c73eb30e073.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.showmars.com/?utm_source=google&utm_medium=Yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=2784878521723453067&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "showmars-northlake-mall",
      "poi_latitude": "35.352377",
      "poi_longitude": "-80.85132999999999",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-921-7775",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bcb5-724e-82df-df3f03a5fe55.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bcb5-724e-82df-df3f03a5fe55",
        "storage_key": "property/5690269169090560/019f14eb-bcb5-724e-82df-df3f03a5fe55.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnycdKFWmVogRi_7wtULgpSY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "greek_restaurant"
    },
    {
      "id": "ec_476a358d2318f33d4d76726b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "8411 Northlake Commons Blvd, Charlotte, NC 28216, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14ef-f1e2-7748-a58a-dfdb329a1a90.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-f1e2-7748-a58a-dfdb329a1a90",
        "storage_key": "property/5690269169090560/019f14ef-f1e2-7748-a58a-dfdb329a1a90.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/nc/northlake-parkway?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=5418797977454091958&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "35.3497317",
      "poi_longitude": "-80.8564731",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 704-599-2330",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bcb5-724e-82df-df3f03a5fe55.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bcb5-724e-82df-df3f03a5fe55",
        "storage_key": "property/5690269169090560/019f14eb-bcb5-724e-82df-df3f03a5fe55.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPQdakP-mVogRtp7B6wxwM0s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "ec_f130c62cd3b8a3da1ada9e02",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Chili's Grill & Bar",
      "poi_type": "Restaurants",
      "poi_address": "8325 Northlake Commons Blvd, Charlotte, NC 28216, USA",
      "poi_short_description": "Family-friendly chain serving classic Tex-Mex & American fare in a Southwestern-style setting.",
      "poi_long_description": "Family-friendly chain serving classic Tex-Mex & American fare in a Southwestern-style setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14ef-ea1a-772b-af28-7e19bd8c820f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-ea1a-772b-af28-7e19bd8c820f",
        "storage_key": "property/5690269169090560/019f14ef-ea1a-772b-af28-7e19bd8c820f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.chilis.com/locations/us/north-carolina/charlotte/northlake-mall?utm_source=google&utm_medium=local&utm_campaign=Chilis",
      "poi_directions_map_url": "https://maps.google.com/?cid=4751846260554603946&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chilis-grill--bar",
      "poi_latitude": "35.348469",
      "poi_longitude": "-80.85649099999999",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 704-494-8403",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bcb5-724e-82df-df3f03a5fe55.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bcb5-724e-82df-df3f03a5fe55",
        "storage_key": "property/5690269169090560/019f14eb-bcb5-724e-82df-df3f03a5fe55.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-WOru_-mVogRqh2gY__y8UE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_a9e3165d86121fde5c02fcc7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Fox & Hound - Northlake",
      "poi_type": "Restaurants",
      "poi_address": "9325 Center Lake Dr #200, Charlotte, NC 28216, USA",
      "poi_short_description": "Burgers, flatbreads & other American fare, plus cocktails, in a sports-bar setting.",
      "poi_long_description": "Burgers, flatbreads & other American fare, plus cocktails, in a sports-bar setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14ef-f8f9-709b-a936-f4b5cad74504.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-f8f9-709b-a936-f4b5cad74504",
        "storage_key": "property/5690269169090560/019f14ef-f8f9-709b-a936-f4b5cad74504.webp",
        "width": 1280,
        "height": 887
      },
      "poi_business_url": "https://www.foxandhound.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2290138893644377409&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fox--hound---northlake",
      "poi_latitude": "35.3491644",
      "poi_longitude": "-80.8551537",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-509-2853",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bcb5-724e-82df-df3f03a5fe55.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bcb5-724e-82df-df3f03a5fe55",
        "storage_key": "property/5690269169090560/019f14eb-bcb5-724e-82df-df3f03a5fe55.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJi-iN6P-mVogRQa36qTA1yB8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_413338aae137277532f9a5dc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Buffalo Wild Wings",
      "poi_type": "Restaurants",
      "poi_address": "9402 Northlake W Dr Suite 103 Suite 103, Charlotte, NC 28216, USA",
      "poi_short_description": "Chain dishing up wings, tenders & burgers, plus sauces ranging from sweet to very spicy.",
      "poi_long_description": "Chain dishing up wings, tenders & burgers, plus sauces ranging from sweet to very spicy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14ef-e8f8-711c-a5ae-e35ff20129a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-e8f8-711c-a5ae-e35ff20129a0",
        "storage_key": "property/5690269169090560/019f14ef-e8f8-711c-a5ae-e35ff20129a0.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.buffalowildwings.com/locations/us/nc/charlotte/9402-northlake-west-drive,-suite-103/sports-bar-815?utm_source=google-my-business&utm_medium=organic&utm_campaign=website-link&y_source=1_MjAxNjYxMTMyNi03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=9523616322823880512&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "buffalo-wild-wings",
      "poi_latitude": "35.3468253",
      "poi_longitude": "-80.8608276",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 704-392-6452",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bcb5-724e-82df-df3f03a5fe55.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bcb5-724e-82df-df3f03a5fe55",
        "storage_key": "property/5690269169090560/019f14eb-bcb5-724e-82df-df3f03a5fe55.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJUSwKGPmmVogRQH8HW5auKoQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_wings_restaurant"
    },
    {
      "id": "ec_a52ae95b193617674e7bbb85",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "East Coast Wings + Grill",
      "poi_type": "Restaurants",
      "poi_address": "9711 Northlake Centre Pkwy, Charlotte, NC 28216, USA",
      "poi_short_description": "American grill chain specializing in chicken wings in many flavors & levels of heat.",
      "poi_long_description": "American grill chain specializing in chicken wings in many flavors & levels of heat.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14ef-f24b-70ea-876f-70ff9a2b0769.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-f24b-70ea-876f-70ff9a2b0769",
        "storage_key": "property/5690269169090560/019f14ef-f24b-70ea-876f-70ff9a2b0769.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.eastcoastwings.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5269429996199539408&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "east-coast-wings--grill",
      "poi_latitude": "35.347646",
      "poi_longitude": "-80.8588075",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 704-494-4174",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bcb5-724e-82df-df3f03a5fe55.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bcb5-724e-82df-df3f03a5fe55",
        "storage_key": "property/5690269169090560/019f14eb-bcb5-724e-82df-df3f03a5fe55.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJi-8k_f6mVogR0PJCtKnGIEk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_wings_restaurant"
    },
    {
      "id": "ec_6725390f0ea10d1110764a11",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Rooster's Wood-fired Kitchen Ballantyne",
      "poi_type": "Restaurants",
      "poi_address": "15110 Bowl St #101, Charlotte, NC 28277, USA",
      "poi_short_description": "Upscale menu of Southern food & dishes with international influences made from local ingredients.",
      "poi_long_description": "Upscale menu of Southern food & dishes with international influences made from local ingredients.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14ef-f9ca-745e-a97f-79fa0e1699f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-f9ca-745e-a97f-79fa0e1699f1",
        "storage_key": "property/5690269169090560/019f14ef-f9ca-745e-a97f-79fa0e1699f1.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.roosterskitchen.com/ballantyne",
      "poi_directions_map_url": "https://maps.google.com/?cid=17093347024850541206&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "roosters-wood-fired-kitchen-ballantyne",
      "poi_latitude": "35.0573504",
      "poi_longitude": "-80.84518539999999",
      "poi_miles_from_property": "22.8 mi",
      "poi_walking_minutes": "8 hours 24 mins",
      "poi_biking_minutes": "2 hours 20 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+1 980-366-1010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bcb5-724e-82df-df3f03a5fe55.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bcb5-724e-82df-df3f03a5fe55",
        "storage_key": "property/5690269169090560/019f14eb-bcb5-724e-82df-df3f03a5fe55.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJeRUUGiWdVogRllqy_o3EN-0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_d0360ce2c5ae8ff1dfe4e9f8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Juniper Grill - Ballantyne",
      "poi_type": "Restaurants",
      "poi_address": "15235 John J Delaney Dr, Charlotte, NC 28277, USA",
      "poi_short_description": "Southwestern eats such as tortilla soup & fish tacos join juice margaritas in a cozy space.",
      "poi_long_description": "Southwestern eats such as tortilla soup & fish tacos join juice margaritas in a cozy space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14ef-fb5c-741b-8c12-d8c741d74c70.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-fb5c-741b-8c12-d8c741d74c70",
        "storage_key": "property/5690269169090560/019f14ef-fb5c-741b-8c12-d8c741d74c70.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://junipergrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12132307481267603869&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "juniper-grill---ballantyne",
      "poi_latitude": "35.0541758",
      "poi_longitude": "-80.84836349999999",
      "poi_miles_from_property": "22.9 mi",
      "poi_walking_minutes": "8 hours 29 mins",
      "poi_biking_minutes": "2 hours 22 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+1 704-490-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bcb5-724e-82df-df3f03a5fe55.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bcb5-724e-82df-df3f03a5fe55",
        "storage_key": "property/5690269169090560/019f14eb-bcb5-724e-82df-df3f03a5fe55.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnUJXyiidVogRnQnF3l-dXqg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_67f494f23c109cc11d090c1e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Miró Spanish Grille",
      "poi_type": "Restaurants",
      "poi_address": "12239 N Community House Rd #102, Charlotte, NC 28277, USA",
      "poi_short_description": "Spanish tapas & full entrees served in a modern, upscale-casual setting with an outdoor patio.",
      "poi_long_description": "Spanish tapas & full entrees served in a modern, upscale-casual setting with an outdoor patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14ef-fd9e-72ce-a863-b3177f7456ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-fd9e-72ce-a863-b3177f7456ca",
        "storage_key": "property/5690269169090560/019f14ef-fd9e-72ce-a863-b3177f7456ca.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.mirospanishgrille.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12005691162743340551&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mir-spanish-grille",
      "poi_latitude": "35.0687221",
      "poi_longitude": "-80.8412207",
      "poi_miles_from_property": "21.7 mi",
      "poi_walking_minutes": "8 hours 0 mins",
      "poi_biking_minutes": "2 hours 12 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 704-540-7374",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bcb5-724e-82df-df3f03a5fe55.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bcb5-724e-82df-df3f03a5fe55",
        "storage_key": "property/5690269169090560/019f14eb-bcb5-724e-82df-df3f03a5fe55.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJHb2tjF6dVogRB_5c7oDInKY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "spanish_restaurant"
    },
    {
      "id": "ec_7cc4f7ff467f7adf0f0ab9bf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "4120 Sunset Rd, Charlotte, NC 28216, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14ef-ff29-75a7-baf0-9189b4759ad8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ef-ff29-75a7-baf0-9189b4759ad8",
        "storage_key": "property/5690269169090560/019f14ef-ff29-75a7-baf0-9189b4759ad8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://info.aldi.us/stores/l/nc/charlotte/4120-sunset-road/f892",
      "poi_directions_map_url": "https://maps.google.com/?cid=3197884817787407722&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "35.304218",
      "poi_longitude": "-80.85925999999999",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bc99-7353-b218-ea523a91a930.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bc99-7353-b218-ea523a91a930",
        "storage_key": "property/5690269169090560/019f14eb-bc99-7353-b218-ea523a91a930.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd74pdiuhVogRak3VdEwrYSw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_0a32c0af714bb0620fa71b19",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Food Lion",
      "poi_type": "Shopping & Retail",
      "poi_address": "4001 Sunset Rd, Charlotte, NC 28216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-083b-719f-8c7b-bbbdc40b9776.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-083b-719f-8c7b-bbbdc40b9776",
        "storage_key": "property/5690269169090560/019f14f0-083b-719f-8c7b-bbbdc40b9776.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.foodlion.com/nc/charlotte/4001-sunset-rd-w?y_source=1_NTA0NjM0OC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=4044416625987588736&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "food-lion",
      "poi_latitude": "35.3055989",
      "poi_longitude": "-80.8606236",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 704-393-3754",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bc99-7353-b218-ea523a91a930.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bc99-7353-b218-ea523a91a930",
        "storage_key": "property/5690269169090560/019f14eb-bc99-7353-b218-ea523a91a930.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE8PrmSyhVogRgJKsO36nIDg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_2293c9728061da3e25c9c95c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Family Dollar",
      "poi_type": "Shopping & Retail",
      "poi_address": "4005 Sunset Rd, Charlotte, NC 28216, USA",
      "poi_short_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_long_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-04af-7068-a560-8e036fc7046e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-04af-7068-a560-8e036fc7046e",
        "storage_key": "property/5690269169090560/019f14f0-04af-7068-a560-8e036fc7046e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.familydollar.com/nc/charlotte/4005-sunset-rd?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=12738492242363275162&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "family-dollar",
      "poi_latitude": "35.3061656",
      "poi_longitude": "-80.8599833",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 980-218-0311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bcb7-754f-a96c-c90c952ad649.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bcb7-754f-a96c-c90c952ad649",
        "storage_key": "property/5690269169090560/019f14eb-bcb7-754f-a96c-c90c952ad649.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJp5-zfCuhVogRmtch-DM3yLA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "ec_e922bac15e6c5c43745e1662",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "5100 Beatties Ford Rd, Charlotte, NC 28216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-012b-7225-b686-dfbc87e284bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-012b-7225-b686-dfbc87e284bf",
        "storage_key": "property/5690269169090560/019f14f0-012b-7225-b686-dfbc87e284bf.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/charlotte-nc-pharmacies/5100-beatties-ford-rd-charlotte-nc-28216/storeid=5445?WT.mc_id=LS_GOOGLE_RX_5445",
      "poi_directions_map_url": "https://maps.google.com/?cid=1067722543449476141&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "35.305596",
      "poi_longitude": "-80.8578918",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 704-391-9341",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-e551-77ca-8224-751ae1f36036.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e551-77ca-8224-751ae1f36036",
        "storage_key": "property/5690269169090560/019f14f0-e551-77ca-8224-751ae1f36036.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4SuSFyuhVogRLYz7CP9P0Q4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_87930bf102618e0281db0282",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "5040 Beatties Ford Rd, Charlotte, NC 28216, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-0c83-70a8-a8ae-a531e5de6155.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-0c83-70a8-a8ae-a531e5de6155",
        "storage_key": "property/5690269169090560/019f14f0-0c83-70a8-a8ae-a531e5de6155.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-5040+beatties+ford+rd-charlotte-nc-28216/id=10275",
      "poi_directions_map_url": "https://maps.google.com/?cid=12031644628365451049&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "35.3047104",
      "poi_longitude": "-80.8571932",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 704-394-1714",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bc97-715e-965b-a20400c4c50d",
        "storage_key": "property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuScYAiuhVogRKZ91CQv9-KY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_5d18fc52eedca5946a5e2084",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Express Mart",
      "poi_type": "Shopping & Retail",
      "poi_address": "3814 Brookshire Blvd, Charlotte, NC 28216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8679942580265001311&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "express-mart",
      "poi_latitude": "35.2639453",
      "poi_longitude": "-80.880029",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 704-399-7928",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-e552-77dc-861c-c4bfbccb9e46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e552-77dc-861c-c4bfbccb9e46",
        "storage_key": "property/5690269169090560/019f14f0-e552-77dc-861c-c4bfbccb9e46.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJERw9OJ6hVogRX6F718lZdXg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_ff545281dffaf12ec7a29c8c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Beatties Ford Express",
      "poi_type": "Shopping & Retail",
      "poi_address": "1121 A, 1121 Beatties Ford Rd, Charlotte, NC 28216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12961943061442257100&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beatties-ford-express",
      "poi_latitude": "35.2537753",
      "poi_longitude": "-80.856477",
      "poi_miles_from_property": "7.5 mi",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 704-373-1155",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-e552-77dc-861c-c4bfbccb9e46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e552-77dc-861c-c4bfbccb9e46",
        "storage_key": "property/5690269169090560/019f14f0-e552-77dc-861c-c4bfbccb9e46.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJSzadcq2hVogRzOAaAIoS4rM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_39365918e86527abbb9645e5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Circle K",
      "poi_type": "Shopping & Retail",
      "poi_address": "Sunset Rd 4518 & 4530, Charlotte, NC 28216, USA",
      "poi_short_description": "Convenience store and gas station chain supplying snacks, beverages, and an ATM.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-11f1-75f8-a788-a0aefb290393.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-11f1-75f8-a788-a0aefb290393",
        "storage_key": "property/5690269169090560/019f14f0-11f1-75f8-a788-a0aefb290393.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.circlek.com/store-locator/US/charlotte/4518-4530-sunset-rd/2705118?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=1005761692186815675&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k",
      "poi_latitude": "35.3063381",
      "poi_longitude": "-80.8522414",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 704-393-1788",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-e552-77dc-861c-c4bfbccb9e46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e552-77dc-861c-c4bfbccb9e46",
        "storage_key": "property/5690269169090560/019f14f0-e552-77dc-861c-c4bfbccb9e46.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJIUStK9WgVogRu6x9J-4u9Q0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_6fc2983ec732afecda650618",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "9820 Callabridge Ct, Charlotte, NC 28216, USA",
      "poi_short_description": "Mass retailer with electronics, toys, sporting goods, grocery and houseware departments, plus an auto repair shop.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-1142-721b-8ca2-8543cf24cec1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-1142-721b-8ca2-8543cf24cec1",
        "storage_key": "property/5690269169090560/019f14f0-1142-721b-8ca2-8543cf24cec1.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/5481-charlotte-nc/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=10141959910278039148&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "35.329383",
      "poi_longitude": "-80.9456853",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 704-392-3338",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bcb7-754f-a96c-c90c952ad649.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bcb7-754f-a96c-c90c952ad649",
        "storage_key": "property/5690269169090560/019f14eb-bcb7-754f-a96c-c90c952ad649.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ3YhOd4mkVogRbAZg0s16v4w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_173b64bb8da11f34b4227a67",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Compare Foods Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "5300 Sunset Rd, Charlotte, NC 28269, USA",
      "poi_short_description": "Full-service grocery store providing meat, seafood & produce, plus pantry staples.",
      "poi_long_description": "Full-service grocery store providing meat, seafood & produce, plus pantry staples.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-12bd-748f-b4fe-34ffdf1e0a20.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-12bd-748f-b4fe-34ffdf1e0a20",
        "storage_key": "property/5690269169090560/019f14f0-12bd-748f-b4fe-34ffdf1e0a20.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.compareclt.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14527369530445606901&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "compare-foods-supermarket",
      "poi_latitude": "35.3067398",
      "poi_longitude": "-80.8407363",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 980-636-1535",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bc99-7353-b218-ea523a91a930.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bc99-7353-b218-ea523a91a930",
        "storage_key": "property/5690269169090560/019f14eb-bc99-7353-b218-ea523a91a930.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgwopKZmnVogR9S8LX56Vm8k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_09d72d9ebf9eb5044b0474d2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Long Creek Elementary",
      "poi_type": "Education",
      "poi_address": "9213-A Beatties Ford Rd, Huntersville, NC 28078, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.cmsk12.org/longcreekES",
      "poi_directions_map_url": "https://maps.google.com/?cid=12998200535644621701&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "long-creek-elementary",
      "poi_latitude": "35.3495149",
      "poi_longitude": "-80.8907133",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 980-343-6095",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bca5-77c3-b069-7ad34a26e8f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bca5-77c3-b069-7ad34a26e8f9",
        "storage_key": "property/5690269169090560/019f14eb-bca5-77c3-b069-7ad34a26e8f9.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJS1D0sIemVogRhctjDoXiYrQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_0b67c4287fb2429e649850fa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "J.M. Alexander Middle School",
      "poi_type": "Education",
      "poi_address": "12010 Hambright Rd, Huntersville, NC 28078, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-15d7-7744-93d5-9f7f236a6d92.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-15d7-7744-93d5-9f7f236a6d92",
        "storage_key": "property/5690269169090560/019f14f0-15d7-7744-93d5-9f7f236a6d92.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cmsk12.org/jmalexanderMS",
      "poi_directions_map_url": "https://maps.google.com/?cid=17616856298860884756&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jm-alexander-middle-school",
      "poi_latitude": "35.3761986",
      "poi_longitude": "-80.8383824",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 980-343-3830",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bca5-77c3-b069-7ad34a26e8f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bca5-77c3-b069-7ad34a26e8f9",
        "storage_key": "property/5690269169090560/019f14eb-bca5-77c3-b069-7ad34a26e8f9.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJXYxbqMOnVogRFLO0OHele_Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_8923c1a56b6af29d3c3c604f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "North Mecklenburg High School",
      "poi_type": "Education",
      "poi_address": "11201 Old Statesville Rd, Huntersville, NC 28078, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-1bb9-70fd-a30e-2a4600d7daba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-1bb9-70fd-a30e-2a4600d7daba",
        "storage_key": "property/5690269169090560/019f14f0-1bb9-70fd-a30e-2a4600d7daba.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cmsk12.org/northmecklenburgHS",
      "poi_directions_map_url": "https://maps.google.com/?cid=4042146081349534534&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-mecklenburg-high-school",
      "poi_latitude": "35.3726485",
      "poi_longitude": "-80.83415149999999",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 980-343-3840",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bca5-77c3-b069-7ad34a26e8f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bca5-77c3-b069-7ad34a26e8f9",
        "storage_key": "property/5690269169090560/019f14eb-bca5-77c3-b069-7ad34a26e8f9.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVyweNsCnVogRRoMT3XGWGDg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_6f01771e5c4d7ab3af406437",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Francis Bradley Middle School",
      "poi_type": "Education",
      "poi_address": "13345 Beatties Ford Rd, Huntersville, NC 28078, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-1641-7043-b9e5-022d101d0dc4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-1641-7043-b9e5-022d101d0dc4",
        "storage_key": "property/5690269169090560/019f14f0-1641-7043-b9e5-022d101d0dc4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cmsk12.org/francisbradleyMS",
      "poi_directions_map_url": "https://maps.google.com/?cid=785781666744128334&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "francis-bradley-middle-school",
      "poi_latitude": "35.3967674",
      "poi_longitude": "-80.92445710000001",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 980-343-5750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bca5-77c3-b069-7ad34a26e8f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bca5-77c3-b069-7ad34a26e8f9",
        "storage_key": "property/5690269169090560/019f14eb-bca5-77c3-b069-7ad34a26e8f9.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJC-QrTIqlVogRTlNMPUOo5wo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_603bfcfbe4004dbbab74994f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Hopewell High",
      "poi_type": "Education",
      "poi_address": "11530 Beatties Ford Rd, Huntersville, NC 28078, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-252a-7664-b840-51636a7bb076.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-252a-7664-b840-51636a7bb076",
        "storage_key": "property/5690269169090560/019f14f0-252a-7664-b840-51636a7bb076.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cmsk12.org/hopewellHS",
      "poi_directions_map_url": "https://maps.google.com/?cid=15410852108760448485&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hopewell-high",
      "poi_latitude": "35.3792799",
      "poi_longitude": "-80.910185",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 980-343-5988",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bca5-77c3-b069-7ad34a26e8f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bca5-77c3-b069-7ad34a26e8f9",
        "storage_key": "property/5690269169090560/019f14eb-bca5-77c3-b069-7ad34a26e8f9.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZaa_8uelVogR5f2-vFdY3tU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_00730c116732d62f7cc2eb22",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Movement School Northwest",
      "poi_type": "Education",
      "poi_address": "8015 Bellhaven Blvd, Charlotte, NC 28216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.movementschools.org/campus/northwest-elementary/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11722104324391026561&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "movement-school-northwest",
      "poi_latitude": "35.3004209",
      "poi_longitude": "-80.9336682",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 980-431-5330",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bca5-77c3-b069-7ad34a26e8f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bca5-77c3-b069-7ad34a26e8f9",
        "storage_key": "property/5690269169090560/019f14eb-bca5-77c3-b069-7ad34a26e8f9.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4Zn9lLKjVogRgb9l08ZHraI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_a321c05ed79a71bf99fe7e64",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Central Piedmont Community College - Merancas Campus",
      "poi_type": "Education",
      "poi_address": "11930 Verhoeff Dr, Huntersville, NC 28078, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-938f-74a9-9dcf-78654d8de6cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14eb-938f-74a9-9dcf-78654d8de6cb",
        "storage_key": "property/5690269169090560/019f14eb-938f-74a9-9dcf-78654d8de6cb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cpcc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16605828799299733723&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-piedmont-community-college---merancas-campus",
      "poi_latitude": "35.3928478",
      "poi_longitude": "-80.8405035",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 704-330-2722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bca5-77c3-b069-7ad34a26e8f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bca5-77c3-b069-7ad34a26e8f9",
        "storage_key": "property/5690269169090560/019f14eb-bca5-77c3-b069-7ad34a26e8f9.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJbd0bJnaoVogR20g2v0_Bc-Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_03cef2a1803abc5baac087a9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Johnson C. Smith University",
      "poi_type": "Education",
      "poi_address": "100 Beatties Ford Rd, Charlotte, NC 28216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-263d-72e8-ad39-f12cfa4e59a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-263d-72e8-ad39-f12cfa4e59a3",
        "storage_key": "property/5690269169090560/019f14f0-263d-72e8-ad39-f12cfa4e59a3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.jcsu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2580739316008437392&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnson-c-smith-university",
      "poi_latitude": "35.2433851",
      "poi_longitude": "-80.85579349999999",
      "poi_miles_from_property": "8.3 mi",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 704-378-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bca5-77c3-b069-7ad34a26e8f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bca5-77c3-b069-7ad34a26e8f9",
        "storage_key": "property/5690269169090560/019f14eb-bca5-77c3-b069-7ad34a26e8f9.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIRduPrWhVogRkEaRDLyg0CM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_35644660e24d59467143c30d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "University of North Carolina at Charlotte",
      "poi_type": "Education",
      "poi_address": "9201 University City Blvd, Charlotte, NC 28223, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-23f0-72bc-b402-908f433183df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-23f0-72bc-b402-908f433183df",
        "storage_key": "property/5690269169090560/019f14f0-23f0-72bc-b402-908f433183df.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.charlotte.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7728009800198595827&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-north-carolina-at-charlotte",
      "poi_latitude": "35.3074169",
      "poi_longitude": "-80.73521219999999",
      "poi_miles_from_property": "11.2 mi",
      "poi_walking_minutes": "4 hours 9 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 704-687-8622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bca5-77c3-b069-7ad34a26e8f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bca5-77c3-b069-7ad34a26e8f9",
        "storage_key": "property/5690269169090560/019f14eb-bca5-77c3-b069-7ad34a26e8f9.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVyOp0BocVIgR8yST8fdnP2s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_8878713886d7758fbe4e93bc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Mountain Island Lake Academy",
      "poi_type": "Education",
      "poi_address": "7905 Pleasant Grove Rd, Charlotte, NC 28216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.cmsk12.org/mountainislandlakeacademyES",
      "poi_directions_map_url": "https://maps.google.com/?cid=1304685110963848454&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mountain-island-lake-academy",
      "poi_latitude": "35.3079519",
      "poi_longitude": "-80.9287336",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 980-343-6948",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bca5-77c3-b069-7ad34a26e8f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bca5-77c3-b069-7ad34a26e8f9",
        "storage_key": "property/5690269169090560/019f14eb-bca5-77c3-b069-7ad34a26e8f9.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJjyCyPImjVogRBsW9JjIsGxI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_3f3fa3068c8e171465f566ad",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "AMC Northlake 14",
      "poi_type": "Entertainment",
      "poi_address": "7325 Northlake Mall Dr, Charlotte, NC 28216, USA",
      "poi_short_description": "Comfortable theater featuring reclining seats, clean toilets and kind staff.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-2fa6-75c9-98b8-61aa6f0c17b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-2fa6-75c9-98b8-61aa6f0c17b2",
        "storage_key": "property/5690269169090560/019f14f0-2fa6-75c9-98b8-61aa6f0c17b2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/charlotte/amc-northlake-14?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=11641706098324670943&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-northlake-14",
      "poi_latitude": "35.353584",
      "poi_longitude": "-80.850346",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-596-2137",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-e552-77dc-861c-cbb35d03e87a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e552-77dc-861c-cbb35d03e87a",
        "storage_key": "property/5690269169090560/019f14f0-e552-77dc-861c-cbb35d03e87a.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJb55buKunVogR3wkkGgSmj6E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_212bc67261eb36fa26983f44",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "TD Amp Ballantyne",
      "poi_type": "Entertainment",
      "poi_address": "11115 Upper Ave, Charlotte, NC 28277, USA",
      "poi_short_description": "Outdoor music amphitheater also hosting films, at new Ballantyne Reimagined project.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-3722-7589-b9fa-0433fbccdceb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-3722-7589-b9fa-0433fbccdceb",
        "storage_key": "property/5690269169090560/019f14f0-3722-7589-b9fa-0433fbccdceb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tdampballantyne.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14937080725788649588&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "td-amp-ballantyne",
      "poi_latitude": "35.0593419",
      "poi_longitude": "-80.8473887",
      "poi_miles_from_property": "22.6 mi",
      "poi_walking_minutes": "8 hours 20 mins",
      "poi_biking_minutes": "2 hours 19 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 704-248-2033",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bc97-715e-965b-a20400c4c50d",
        "storage_key": "property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ70J1hOadVogRdGj3sccrS88",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "ec_7449c170271d4baf4a686eb0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "The Olde Mecklenburg Restaurant & Biergarten at Ballantyne",
      "poi_type": "Entertainment",
      "poi_address": "15025 Bowl St, Charlotte, NC 28277, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-3913-76c7-a839-cb188619e473.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-3913-76c7-a839-cb188619e473",
        "storage_key": "property/5690269169090560/019f14f0-3913-76c7-a839-cb188619e473.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://ombbeer.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5238904532443810007&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-olde-mecklenburg-restaurant--biergarten-at-ballantyne",
      "poi_latitude": "35.0566421",
      "poi_longitude": "-80.84553489999999",
      "poi_miles_from_property": "22.8 mi",
      "poi_walking_minutes": "8 hours 25 mins",
      "poi_biking_minutes": "2 hours 20 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+1 984-253-1980",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-e5a8-734c-a7e5-37cbbff75305.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e5a8-734c-a7e5-37cbbff75305",
        "storage_key": "property/5690269169090560/019f14f0-e5a8-734c-a7e5-37cbbff75305.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTT5Io16dVogR10h_VOpTtEg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "beer_garden"
    },
    {
      "id": "ec_6f5e9a6982bdb6ccf8a0eeae",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Topgolf Charlotte - Southwest",
      "poi_type": "Entertainment",
      "poi_address": "8024 Savoy Corporate Dr, Charlotte, NC 28273, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-22ce-7359-882e-512b84bc4628.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-22ce-7359-882e-512b84bc4628",
        "storage_key": "property/5690269169090560/019f14f0-22ce-7359-882e-512b84bc4628.webp",
        "width": 1000,
        "height": 677
      },
      "poi_business_url": "https://topgolf.com/us/charlotte/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15291613169624602327&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "topgolf-charlotte---southwest",
      "poi_latitude": "35.1535306",
      "poi_longitude": "-80.9449111",
      "poi_miles_from_property": "18.3 mi",
      "poi_walking_minutes": "6 hours 47 mins",
      "poi_biking_minutes": "1 hour 44 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 704-612-4745",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bcb5-724e-82df-df3f03a5fe55.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bcb5-724e-82df-df3f03a5fe55",
        "storage_key": "property/5690269169090560/019f14eb-bcb5-724e-82df-df3f03a5fe55.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJq3u8zXCZVogR19Yoyii5NtQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_757c4fdaf54c3814eeedcead",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Truliant Amphitheater",
      "poi_type": "Entertainment",
      "poi_address": "707 Pavilion Blvd, Charlotte, NC 28262, USA",
      "poi_short_description": "Sprawling outdoor venue for a variety of musical acts, from country to R&B, plus festivals & events.",
      "poi_long_description": "Sprawling outdoor venue for a variety of musical acts, from country to R&B, plus festivals & events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-4213-73ef-96a3-70ce90278b51.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-4213-73ef-96a3-70ce90278b51",
        "storage_key": "property/5690269169090560/019f14f0-4213-73ef-96a3-70ce90278b51.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.truliantamp.com/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=8876681391951831978&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "truliant-amphitheater",
      "poi_latitude": "35.3271592",
      "poi_longitude": "-80.7123113",
      "poi_miles_from_property": "12.7 mi",
      "poi_walking_minutes": "4 hours 41 mins",
      "poi_biking_minutes": "1 hour 16 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 704-549-5555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bc97-715e-965b-a20400c4c50d",
        "storage_key": "property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC2hDco8bVIgRquOb_7FOMHs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amphitheatre"
    },
    {
      "id": "ec_f46f70822b3c0f9f3c7964a7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Carowinds",
      "poi_type": "Entertainment",
      "poi_address": "North Carolina, USA",
      "poi_short_description": "Seasonal, family-friendly amusement park featuring towering roller coasters, waterslides & more.",
      "poi_long_description": "Seasonal, family-friendly amusement park featuring towering roller coasters, waterslides & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-4579-70ad-9b68-51a119b0fa45.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-4579-70ad-9b68-51a119b0fa45",
        "storage_key": "property/5690269169090560/019f14f0-4579-70ad-9b68-51a119b0fa45.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.carowinds.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3638331865982573054&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carowinds",
      "poi_latitude": "35.1024013",
      "poi_longitude": "-80.9412735",
      "poi_miles_from_property": "21.6 mi",
      "poi_walking_minutes": "8 hours 0 mins",
      "poi_biking_minutes": "2 hours 13 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+1 704-588-2600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bc97-715e-965b-a20400c4c50d",
        "storage_key": "property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLVWj3q-PVogR_hngLo7zfTI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "ec_3091e7e74a010d6e83091ddf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Discovery Place Science",
      "poi_type": "Entertainment",
      "poi_address": "168 W 6th St, Charlotte, NC 28202, USA",
      "poi_short_description": "Kids' science & tech museum with interactive exhibits, an aquarium, rain forest & IMAX theater.",
      "poi_long_description": "Kids' science & tech museum with interactive exhibits, an aquarium, rain forest & IMAX theater.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-34a9-7726-9f3b-9feef73073f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-34a9-7726-9f3b-9feef73073f4",
        "storage_key": "property/5690269169090560/019f14f0-34a9-7726-9f3b-9feef73073f4.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "http://discoveryplace.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8672994214166199027&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "discovery-place-science",
      "poi_latitude": "35.229441",
      "poi_longitude": "-80.8409271",
      "poi_miles_from_property": "9.6 mi",
      "poi_walking_minutes": "3 hours 35 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 704-327-2189",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bcab-73cd-95a1-1ccfc5ba5e71.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bcab-73cd-95a1-1ccfc5ba5e71",
        "storage_key": "property/5690269169090560/019f14eb-bcab-73cd-95a1-1ccfc5ba5e71.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ-LB1SSgVogR8_pkSkmqXHg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_7b06b5d82fc553bc6edd5a88",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "NASCAR Hall of Fame",
      "poi_type": "Entertainment",
      "poi_address": "400 E M.L.K. Jr Blvd, Charlotte, NC 28202, USA",
      "poi_short_description": "Shrine to stock-car drivers past & present, plus a museum with interactive exhibits & a theater.",
      "poi_long_description": "Shrine to stock-car drivers past & present, plus a museum with interactive exhibits & a theater.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-4127-734d-9a5b-628659c66c8f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-4127-734d-9a5b-628659c66c8f",
        "storage_key": "property/5690269169090560/019f14f0-4127-734d-9a5b-628659c66c8f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.nascarhall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12564449458462117353&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nascar-hall-of-fame",
      "poi_latitude": "35.2211366",
      "poi_longitude": "-80.8439538",
      "poi_miles_from_property": "10.3 mi",
      "poi_walking_minutes": "3 hours 49 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 704-654-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bcab-73cd-95a1-1ccfc5ba5e71.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bcab-73cd-95a1-1ccfc5ba5e71",
        "storage_key": "property/5690269169090560/019f14eb-bcab-73cd-95a1-1ccfc5ba5e71.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJyWIVfyigVogR6c37kTbkXa4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_4ce12468949d7e8078552351",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Mint Museum Uptown",
      "poi_type": "Entertainment",
      "poi_address": "at Levine Center for the Arts, 500 S Tryon St, Charlotte, NC 28202, USA",
      "poi_short_description": "Museum showcasing international art, plus live performances & educational programs for all ages.",
      "poi_long_description": "Museum showcasing international art, plus live performances & educational programs for all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-5455-74d9-b9e2-84da59afa351.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-5455-74d9-b9e2-84da59afa351",
        "storage_key": "property/5690269169090560/019f14f0-5455-74d9-b9e2-84da59afa351.webp",
        "width": 1280,
        "height": 977
      },
      "poi_business_url": "http://mintmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3574976966142914753&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mint-museum-uptown",
      "poi_latitude": "35.2244083",
      "poi_longitude": "-80.8480847",
      "poi_miles_from_property": "9.9 mi",
      "poi_walking_minutes": "3 hours 42 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 704-337-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bcab-73cd-95a1-1ccfc5ba5e71.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bcab-73cd-95a1-1ccfc5ba5e71",
        "storage_key": "property/5690269169090560/019f14eb-bcab-73cd-95a1-1ccfc5ba5e71.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6QA5TymgVogRwfAmE5zenDE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "ec_340f05bcc0e8c0fb6f15b891",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Bechtler Museum of Modern Art",
      "poi_type": "Entertainment",
      "poi_address": "420 S Tryon St, Charlotte, NC 28202, USA",
      "poi_short_description": "Mid-20th-century modern art displayed in an elegant 4-story building filled with natural light.",
      "poi_long_description": "Mid-20th-century modern art displayed in an elegant 4-story building filled with natural light.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-4978-71ad-8db7-f5377d0a75fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-4978-71ad-8db7-f5377d0a75fe",
        "storage_key": "property/5690269169090560/019f14f0-4978-71ad-8db7-f5377d0a75fe.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "http://bechtler.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4402061911705097934&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bechtler-museum-of-modern-art",
      "poi_latitude": "35.2244822",
      "poi_longitude": "-80.8473279",
      "poi_miles_from_property": "9.9 mi",
      "poi_walking_minutes": "3 hours 42 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 704-353-9209",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bcab-73cd-95a1-1ccfc5ba5e71.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bcab-73cd-95a1-1ccfc5ba5e71",
        "storage_key": "property/5690269169090560/019f14eb-bcab-73cd-95a1-1ccfc5ba5e71.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJvSzQNSmgVogRzpZ1TvxDFz0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "ec_7c5c1af8aa3eafd9674b3cb2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Novant Health Huntersville Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "10030 Gilead Rd, Huntersville, NC 28078, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-a4ac-701d-90eb-472ae0b12811.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14eb-a4ac-701d-90eb-472ae0b12811",
        "storage_key": "property/5690269169090560/019f14eb-a4ac-701d-90eb-472ae0b12811.webp",
        "width": 1280,
        "height": 842
      },
      "poi_business_url": "https://www.novanthealth.org/locations/medical-centers/huntersville-medical-center/?utm_source=maps.google.com&utm_medium=organic&utm_campaign=GBP&utm_content=MC-06",
      "poi_directions_map_url": "https://maps.google.com/?cid=4170292178518567466&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "novant-health-huntersville-medical-center",
      "poi_latitude": "35.4065406",
      "poi_longitude": "-80.8607439",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 704-316-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bcb4-70ee-b8b7-82cb724336d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bcb4-70ee-b8b7-82cb724336d8",
        "storage_key": "property/5690269169090560/019f14eb-bcb4-70ee-b8b7-82cb724336d8.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJtboxfY-oVogRKmowJqTa3zk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "ec_54f4d1950a62eb17df8409f9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Atrium Health Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "10210 Couloak Dr E, Charlotte, NC 28216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-4aa0-76e8-8529-0f741b341e79.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-4aa0-76e8-8529-0f741b341e79",
        "storage_key": "property/5690269169090560/019f14f0-4aa0-76e8-8529-0f741b341e79.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://atriumhealth.org/locations/detail/atrium-health-urgent-care-mountain-island?utm_source=GMB&utm_medium=Organic&utm_campaign=GCR",
      "poi_directions_map_url": "https://maps.google.com/?cid=11640727610543668664&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atrium-health-urgent-care",
      "poi_latitude": "35.3242932",
      "poi_longitude": "-80.9477716",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 704-801-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bc97-715e-965b-a20400c4c50d",
        "storage_key": "property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfZvUBIakVogRuH2JKRYsjKE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_4e2eb691b83f3d090681f36f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "9841 Northlake Centre Pkwy, Charlotte, NC 28216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-4c92-761c-94c0-8b681d4cffa8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-4c92-761c-94c0-8b681d4cffa8",
        "storage_key": "property/5690269169090560/019f14f0-4c92-761c-94c0-8b681d4cffa8.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.cvs.com/store-locator/charlotte-nc-pharmacies/9841-northlake-centre-pkwy-charlotte-nc-28216/storeid=17168?WT.mc_id=LS_GOOGLE_RX_17168",
      "poi_directions_map_url": "https://maps.google.com/?cid=11852881595992310542&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "35.3502758",
      "poi_longitude": "-80.8600922",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 704-526-3649",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-e551-77ca-8224-751ae1f36036.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e551-77ca-8224-751ae1f36036",
        "storage_key": "property/5690269169090560/019f14f0-e551-77ca-8224-751ae1f36036.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfb1fRv-mVogRDgPjJQPlfaQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_82c5798f014085d408092a2e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "5040 Beatties Ford Rd, Charlotte, NC 28216, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-0c83-70a8-a8ae-a531e5de6155.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-0c83-70a8-a8ae-a531e5de6155",
        "storage_key": "property/5690269169090560/019f14f0-0c83-70a8-a8ae-a531e5de6155.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-5040+beatties+ford+rd-charlotte-nc-28216/id=10275",
      "poi_directions_map_url": "https://maps.google.com/?cid=12031644628365451049&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "35.3047104",
      "poi_longitude": "-80.8571932",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 704-394-1714",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bc97-715e-965b-a20400c4c50d",
        "storage_key": "property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuScYAiuhVogRKZ91CQv9-KY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_edb94b2a540b401563b7c749",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2924 Mt Holly-Huntersville Rd, Charlotte, NC 28214, USA",
      "poi_short_description": "Clean gym chain featuring new equipment, a \"Judege Free Zone\" and a 24/7 schedule.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-9ced-747b-a017-9dab3ba6fbc7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14eb-9ced-747b-a017-9dab3ba6fbc7",
        "storage_key": "property/5690269169090560/019f14eb-9ced-747b-a017-9dab3ba6fbc7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/charlotte-rozzelle-crossing-nc?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=10572226921231912412&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "35.319252",
      "poi_longitude": "-80.9514007",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 980-380-3010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bc97-715e-965b-a20400c4c50d",
        "storage_key": "property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPxBXOeelVogR3I3Z7F4YuJI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_51e86085d303bba2df232440",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "CrossFit 704",
      "poi_type": "Health and Wellness",
      "poi_address": "10806 Reames Rd s, Charlotte, NC 28269, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-5966-735f-9cc5-c0b9bb6d9ff4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-5966-735f-9cc5-c0b9bb6d9ff4",
        "storage_key": "property/5690269169090560/019f14f0-5966-735f-9cc5-c0b9bb6d9ff4.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "http://www.crossfit704.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6634080435000148018&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crossfit-704",
      "poi_latitude": "35.3447808",
      "poi_longitude": "-80.835728",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 704-594-1329",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bc97-715e-965b-a20400c4c50d",
        "storage_key": "property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSTe_lQunVogRMoCNuwH9EFw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_0b71957af9444840090fbf26",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Northlake Chiropractic",
      "poi_type": "Health and Wellness",
      "poi_address": "9325 Center Lake Dr #150, Charlotte, NC 28216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-5387-7738-b844-b7fe36d83416.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-5387-7738-b844-b7fe36d83416",
        "storage_key": "property/5690269169090560/019f14f0-5387-7738-b844-b7fe36d83416.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "http://www.northlakechiro.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=650300803030871668&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northlake-chiropractic",
      "poi_latitude": "35.349308",
      "poi_longitude": "-80.85495499999999",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 704-494-4250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bc97-715e-965b-a20400c4c50d",
        "storage_key": "property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvdtN5v-mVogRdG7OiSJVBgk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chiropractor"
    },
    {
      "id": "ec_0b5d82490237b10b2a3d62ee",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Reflect Vision Care | Northlake Mall",
      "poi_type": "Health and Wellness",
      "poi_address": "6801 Northlake Mall Dr #253, Charlotte, NC 28216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-5db4-711d-925b-974e469dc598.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-5db4-711d-925b-974e469dc598",
        "storage_key": "property/5690269169090560/019f14f0-5db4-711d-925b-974e469dc598.webp",
        "width": 1280,
        "height": 610
      },
      "poi_business_url": "https://www.reflectvisioncare.com/locations/northlake-mall/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3656877679291748670&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "reflect-vision-care--northlake-mall",
      "poi_latitude": "35.3522872",
      "poi_longitude": "-80.8495694",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 704-509-4490",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bc97-715e-965b-a20400c4c50d",
        "storage_key": "property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfzvKOqqnVogRPlE91d_WvzI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_73f16f600c6a3858277c7ace",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Massage Envy",
      "poi_type": "Health and Wellness",
      "poi_address": "9733 Northlake Centre Pkwy, Charlotte, NC 28216, USA",
      "poi_short_description": "Chain spa at Northcrest Shopping Center offering facials, skin care, and massage services.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-56ad-7336-8c58-ee420ea27c43.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-56ad-7336-8c58-ee420ea27c43",
        "storage_key": "property/5690269169090560/019f14f0-56ad-7336-8c58-ee420ea27c43.webp",
        "width": 1000,
        "height": 665
      },
      "poi_business_url": "https://locations.massageenvy.com/north-carolina/charlotte/9733-northlake-centre-parkway.html?utm_source=GMB&utm_medium=useractions&utm_campaign=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=838060245705401219&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "massage-envy",
      "poi_latitude": "35.3485104",
      "poi_longitude": "-80.86020490000001",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 704-596-7800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bc97-715e-965b-a20400c4c50d",
        "storage_key": "property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg31lDv-mVogRg6OlbVpjoQs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "massage_spa"
    },
    {
      "id": "ec_c586518a5679977246c9d3cc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Fitness Jones Training",
      "poi_type": "Health and Wellness",
      "poi_address": "606 Nc Music Factory Blvd, Charlotte, NC 28206, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-5a90-762d-a2f6-a64a885be95d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-5a90-762d-a2f6-a64a885be95d",
        "storage_key": "property/5690269169090560/019f14f0-5a90-762d-a2f6-a64a885be95d.webp",
        "width": 758,
        "height": 760
      },
      "poi_business_url": "https://www.fitnessjonestraining.com/?utm_source=google&utm_medium=wix_google_business_profile&utm_campaign=7331501874980882151",
      "poi_directions_map_url": "https://maps.google.com/?cid=143557621514562273&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fitness-jones-training",
      "poi_latitude": "35.2379074",
      "poi_longitude": "-80.83978739999999",
      "poi_miles_from_property": "9.3 mi",
      "poi_walking_minutes": "3 hours 27 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 704-218-9647",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bc97-715e-965b-a20400c4c50d",
        "storage_key": "property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ17OD9DKhVogR4eosa-UE_gE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "ec_94769e97273abf632a52463b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Long Creek Greenway",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9841 Northlake Centre Pkwy, Charlotte, NC 28216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-7b6c-7216-92f1-1daa6b99058b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-7b6c-7216-92f1-1daa6b99058b",
        "storage_key": "property/5690269169090560/019f14f0-7b6c-7216-92f1-1daa6b99058b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://publicinput.com/LongCreek",
      "poi_directions_map_url": "https://maps.google.com/?cid=6661960119469705280&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "long-creek-greenway",
      "poi_latitude": "35.349001",
      "poi_longitude": "-80.8604127",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bc97-715e-965b-a20400c4c50d",
        "storage_key": "property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qq5p2mVogRQIjPnG4JdFw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "ec_e89a471f60e95c396f552556",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Mallard Creek Greenway - East Terminus",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "201 E Mallard Creek Church Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-ab6d-7471-9b5b-4afe5ae92760.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-ab6d-7471-9b5b-4afe5ae92760",
        "storage_key": "property/5690269169090560/019f14f0-ab6d-7471-9b5b-4afe5ae92760.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mecknc.gov/ParkandRec/Greenways/OpenGreenways/Pages/MallardCreekandClark'sCreek.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=15209037215157520469&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mallard-creek-greenway---east-terminus",
      "poi_latitude": "35.32064940000001",
      "poi_longitude": "-80.73165089999999",
      "poi_miles_from_property": "11.0 mi",
      "poi_walking_minutes": "4 hours 4 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 980-314-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bc97-715e-965b-a20400c4c50d",
        "storage_key": "property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUaiP2cwdVIgRVQgpKcRaEdM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "ec_1747fbf52f035d6c25b80fbe",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Kirk Farm Fields Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "210 E Mallard Creek Church Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "Trail-lined park featuring woods and an open field, plus soccer nets.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-a26b-72cf-9456-6f0ce380ba95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-a26b-72cf-9456-6f0ce380ba95",
        "storage_key": "property/5690269169090560/019f14f0-a26b-72cf-9456-6f0ce380ba95.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mecknc.gov/ParkandRec/Parks/ParksByRegion/NorthRegion/Pages/KirkFarmFields.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=3813087192918391643&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kirk-farm-fields-park",
      "poi_latitude": "35.3221854",
      "poi_longitude": "-80.7308485",
      "poi_miles_from_property": "11.0 mi",
      "poi_walking_minutes": "4 hours 4 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 980-314-1001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bc91-7684-9abd-1f55db4a1334.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bc91-7684-9abd-1f55db4a1334",
        "storage_key": "property/5690269169090560/019f14eb-bc91-7684-9abd-1f55db4a1334.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7azmx3IcVIgRW_t9b5nO6jQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_98ff1abba8a5cb109c754ce8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Mallard Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3001 Johnston Oehler Rd, Charlotte, NC 28269, USA",
      "poi_short_description": "Recreation area featuring 8 soccer fields, a batting cage, and 2 playgrounds, plus a volleyball court.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-7bcf-766b-a439-e92a493a50c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-7bcf-766b-a439-e92a493a50c1",
        "storage_key": "property/5690269169090560/019f14f0-7bcf-766b-a439-e92a493a50c1.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=412983690555762575&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mallard-creek-park",
      "poi_latitude": "35.3614698",
      "poi_longitude": "-80.7624001",
      "poi_miles_from_property": "8.0 mi",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bc91-7684-9abd-1f55db4a1334.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bc91-7684-9abd-1f55db4a1334",
        "storage_key": "property/5690269169090560/019f14eb-bc91-7684-9abd-1f55db4a1334.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJB6J0seEcVIgRjyebfXo2uwU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_93a2fde37c9a5f6a55ad6caf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Clarks Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5435 Hucks Rd, Charlotte, NC 28269, USA",
      "poi_short_description": "Family-friendly park equipped with picnic tables, swing sets, playgrounds, basketball courts, splash pads and tennis courts.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-a781-76cf-bf9b-2a17114ae7cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-a781-76cf-bf9b-2a17114ae7cd",
        "storage_key": "property/5690269169090560/019f14f0-a781-76cf-bf9b-2a17114ae7cd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=16436839230062349110&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clarks-creek-park",
      "poi_latitude": "35.3541742",
      "poi_longitude": "-80.808039",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bc91-7684-9abd-1f55db4a1334.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bc91-7684-9abd-1f55db4a1334",
        "storage_key": "property/5690269169090560/019f14eb-bc91-7684-9abd-1f55db4a1334.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6y6TghinVogRNksSkjFiG-Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_d98ea84aa0f76e4326d72d6d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Clarks Creek Nature Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5542 Hucks Rd, Charlotte, NC 28269, USA",
      "poi_short_description": "Nature preserve featuring trails and a playground, plus basketball and tennis courts.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-7bce-7188-bbe6-f14cd95f6536.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-7bce-7188-bbe6-f14cd95f6536",
        "storage_key": "property/5690269169090560/019f14f0-7bce-7188-bbe6-f14cd95f6536.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://parkandrec.mecknc.gov/Places-to-Visit/Nature",
      "poi_directions_map_url": "https://maps.google.com/?cid=1118185895994378143&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clarks-creek-nature-preserve",
      "poi_latitude": "35.3522197",
      "poi_longitude": "-80.8102792",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 980-314-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bc91-7684-9abd-1f55db4a1334.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bc91-7684-9abd-1f55db4a1334",
        "storage_key": "property/5690269169090560/019f14eb-bc91-7684-9abd-1f55db4a1334.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJf6LFuoCnVogRn8eY4yWYhA8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "ec_bfb2377c0fe2548e6709e035",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "UNC Charlotte Botanical Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9090 Craver Rd, Charlotte, NC 28262, USA",
      "poi_short_description": "Indoor & outdoor displays of plants from around the world, plus workshops, plant sales & free tours.",
      "poi_long_description": "Indoor & outdoor displays of plants from around the world, plus workshops, plant sales & free tours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-8144-74d0-aa98-35adf81299ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-8144-74d0-aa98-35adf81299ab",
        "storage_key": "property/5690269169090560/019f14f0-8144-74d0-aa98-35adf81299ab.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://gardens.uncc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4177973296962421892&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "unc-charlotte-botanical-gardens",
      "poi_latitude": "35.3078198",
      "poi_longitude": "-80.72969499999999",
      "poi_miles_from_property": "11.4 mi",
      "poi_walking_minutes": "4 hours 14 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 704-687-0721",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bc97-715e-965b-a20400c4c50d",
        "storage_key": "property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA6cM9xocVIgRhESD5pMk-zk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "ec_089a6a0883406a07b6ef8c9c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Toby Creek Greenway - Ruth G. Shaw Trailhead (2 miles)",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8541 University City Blvd, Charlotte, NC 28213, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-b739-7380-a3a3-a07139f55eb6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-b739-7380-a3a3-a07139f55eb6",
        "storage_key": "property/5690269169090560/019f14f0-b739-7380-a3a3-a07139f55eb6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.carolinathreadtrail.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13519428957779332624&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "toby-creek-greenway---ruth-g-shaw-trailhead-2-miles",
      "poi_latitude": "35.2968741",
      "poi_longitude": "-80.7414333",
      "poi_miles_from_property": "10.2 mi",
      "poi_walking_minutes": "3 hours 47 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 704-376-2556",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bc97-715e-965b-a20400c4c50d",
        "storage_key": "property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ73PsZ6AeVIgREA6REgKpnrs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "ec_320e4bd79d745ddc16e8e917",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Ribbonwalk Nature Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4601 Nevin Rd, Charlotte, NC 28269, USA",
      "poi_short_description": "Scenic park featuring a large beech tree grove, trails & several species of birds & butterflies.",
      "poi_long_description": "Scenic park featuring a large beech tree grove, trails & several species of birds & butterflies.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-b1a2-766c-b508-f8e33200a172.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-b1a2-766c-b508-f8e33200a172",
        "storage_key": "property/5690269169090560/019f14f0-b1a2-766c-b508-f8e33200a172.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://parkandrec.mecknc.gov/Places-to-Visit/Nature",
      "poi_directions_map_url": "https://maps.google.com/?cid=10225485868296884956&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ribbonwalk-nature-preserve",
      "poi_latitude": "35.2963392",
      "poi_longitude": "-80.8209966",
      "poi_miles_from_property": "6.9 mi",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 980-314-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bc91-7684-9abd-1f55db4a1334.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bc91-7684-9abd-1f55db4a1334",
        "storage_key": "property/5690269169090560/019f14eb-bc91-7684-9abd-1f55db4a1334.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJjeTb0K-gVogR3NKcYzg56I0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "ec_c1d7810afe0d5a5b0cf375f2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "McCullough",
      "poi_type": "Transportation & Transit",
      "poi_address": "8312 N Tryon St, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-8a4e-720e-8aa3-5a80b4a96f17.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-8a4e-720e-8aa3-5a80b4a96f17",
        "storage_key": "property/5690269169090560/019f14f0-8a4e-720e-8aa3-5a80b4a96f17.webp",
        "width": 1280,
        "height": 674
      },
      "poi_business_url": "http://charlottenc.gov/cats/rail/lynx-blue-line/Pages/mccullough-station.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=1260187329938804696&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mccullough",
      "poi_latitude": "35.301124",
      "poi_longitude": "-80.752875",
      "poi_miles_from_property": "10.0 mi",
      "poi_walking_minutes": "3 hours 43 mins",
      "poi_biking_minutes": "1 hour 9 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bc97-715e-965b-a20400c4c50d",
        "storage_key": "property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB_ReviccVIgR2E9zJ7MVfRE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "ec_145c2183317220e52b15ca4e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Tom Hunter Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Charlotte, NC 28213, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-99df-747a-9ac1-af3f0a0aa6a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-99df-747a-9ac1-af3f0a0aa6a8",
        "storage_key": "property/5690269169090560/019f14f0-99df-747a-9ac1-af3f0a0aa6a8.webp",
        "width": 719,
        "height": 490
      },
      "poi_business_url": "http://charlottenc.gov/cats/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=2039373716308956755&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tom-hunter-station",
      "poi_latitude": "35.2779461",
      "poi_longitude": "-80.76628629999999",
      "poi_miles_from_property": "9.8 mi",
      "poi_walking_minutes": "3 hours 39 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bc97-715e-965b-a20400c4c50d",
        "storage_key": "property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5VbfjF8eVIgRUxbdBJdPTRw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "ec_ba2b9caecdc72bbc75e8f534",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "University City Blvd",
      "poi_type": "Transportation & Transit",
      "poi_address": "7205 N Tryon St, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-a20d-7251-b88b-e4141dd7b5a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-a20d-7251-b88b-e4141dd7b5a5",
        "storage_key": "property/5690269169090560/019f14f0-a20d-7251-b88b-e4141dd7b5a5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://charlonbvcsattenc.gov/cats/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=12467337922677263454&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-city-blvd",
      "poi_latitude": "35.2869215",
      "poi_longitude": "-80.76073650000001",
      "poi_miles_from_property": "9.2 mi",
      "poi_walking_minutes": "3 hours 25 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bc97-715e-965b-a20400c4c50d",
        "storage_key": "property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZz4QjIUeVIgRXkzvL8nhBK0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "ec_64d54a49fba2c9b3018e319c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "JW Clay Blvd / UNC Charlotte",
      "poi_type": "Transportation & Transit",
      "poi_address": "9234-9300 N Tryon St, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-adcb-754f-9a04-49ac87fc7417.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-adcb-754f-9a04-49ac87fc7417",
        "storage_key": "property/5690269169090560/019f14f0-adcb-754f-9a04-49ac87fc7417.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.charlottenc.gov/CATS/Rail/LYNX-Stations-and-Park-and-Rides/JW-Clay-Station",
      "poi_directions_map_url": "https://maps.google.com/?cid=9941066239111075827&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jw-clay-blvd--unc-charlotte",
      "poi_latitude": "35.3108328",
      "poi_longitude": "-80.7450265",
      "poi_miles_from_property": "10.8 mi",
      "poi_walking_minutes": "4 hours 1 min",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bc97-715e-965b-a20400c4c50d",
        "storage_key": "property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5wiIej0cVIgR8xfYDhPD9Yk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_e11d4e128760dc084192bc59",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "UNC Charlotte Main Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "9025 Cameron Blvd, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-a14d-746c-8564-7af9c9377e1d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-a14d-746c-8564-7af9c9377e1d",
        "storage_key": "property/5690269169090560/019f14f0-a14d-746c-8564-7af9c9377e1d.webp",
        "width": 1280,
        "height": 957
      },
      "poi_business_url": "http://charlottenc.gov/cats/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=11588625435149076740&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "unc-charlotte-main-station",
      "poi_latitude": "35.3121822",
      "poi_longitude": "-80.73371980000002",
      "poi_miles_from_property": "11.6 mi",
      "poi_walking_minutes": "4 hours 16 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bc97-715e-965b-a20400c4c50d",
        "storage_key": "property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDTHpFBEcVIgRBAkeIW8R06A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "ec_a5142bff4099a4e74628308f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Northlake Mall Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Charlotte, NC 28216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=11574504833305702147&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northlake-mall-park--ride",
      "poi_latitude": "35.352833",
      "poi_longitude": "-80.85521899999999",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bc97-715e-965b-a20400c4c50d",
        "storage_key": "property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVfdxJlWmVogRA286UNLmoKA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_30f6e9d58358841c66911c8b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Riverbend Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Charlotte, NC 28216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8842128954005509861&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riverbend-park-and-ride",
      "poi_latitude": "35.32882",
      "poi_longitude": "-80.94192",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bc97-715e-965b-a20400c4c50d",
        "storage_key": "property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKf5NEWKkVogR5daxoW-NtXo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_c78f3d97c8d1423c76f23f7e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Charlotte Transportation Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Charlotte, NC 28202, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-a07c-70ed-8f7c-33a776c88cdc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-a07c-70ed-8f7c-33a776c88cdc",
        "storage_key": "property/5690269169090560/019f14f0-a07c-70ed-8f7c-33a776c88cdc.webp",
        "width": 1024,
        "height": 768
      },
      "poi_business_url": "http://www.ridetransit.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7843406414498383660&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charlotte-transportation-center",
      "poi_latitude": "35.2243513",
      "poi_longitude": "-80.8413051",
      "poi_miles_from_property": "10.0 mi",
      "poi_walking_minutes": "3 hours 43 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-e5b4-7699-8ac4-1a7c40cafce8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e5b4-7699-8ac4-1a7c40cafce8",
        "storage_key": "property/5690269169090560/019f14f0-e5b4-7699-8ac4-1a7c40cafce8.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ6xY9CWgVogRLEcy7ZNg2Ww",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "ec_0aed7e273084dc183755c217",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Charlotte Douglas International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "5501 Josh Birmingham Pkwy, Charlotte, NC 28208, USA",
      "poi_short_description": "Airport with rocking chairs, free WiFi & a 60-foot outdoor sculpture symbolizing flight.",
      "poi_long_description": "Airport with rocking chairs, free WiFi & a 60-foot outdoor sculpture symbolizing flight.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-b7ef-717f-9d62-8310df8de321.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-b7ef-717f-9d62-8310df8de321",
        "storage_key": "property/5690269169090560/019f14f0-b7ef-717f-9d62-8310df8de321.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cltairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1925933632275654455&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charlotte-douglas-international-airport",
      "poi_latitude": "35.2162994",
      "poi_longitude": "-80.95394280000001",
      "poi_miles_from_property": "17.0 mi",
      "poi_walking_minutes": "6 hours 16 mins",
      "poi_biking_minutes": "1 hour 44 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 704-359-4013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-e5ac-727f-bc66-a0ec7860697d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e5ac-727f-bc66-a0ec7860697d",
        "storage_key": "property/5690269169090560/019f14f0-e5ac-727f-bc66-a0ec7860697d.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJidRKt32YVogRN6fEPG9Kuho",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_06911d525a19ee873b8176f1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "University of North Carolina at Charlotte",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9201 University City Blvd, Charlotte, NC 28223, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-23f0-72bc-b402-908f433183df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-23f0-72bc-b402-908f433183df",
        "storage_key": "property/5690269169090560/019f14f0-23f0-72bc-b402-908f433183df.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.charlotte.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7728009800198595827&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-north-carolina-at-charlotte",
      "poi_latitude": "35.3074169",
      "poi_longitude": "-80.73521219999999",
      "poi_miles_from_property": "11.2 mi",
      "poi_walking_minutes": "4 hours 9 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 704-687-8622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bca5-77c3-b069-7ad34a26e8f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bca5-77c3-b069-7ad34a26e8f9",
        "storage_key": "property/5690269169090560/019f14eb-bca5-77c3-b069-7ad34a26e8f9.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVyOp0BocVIgR8yST8fdnP2s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_93244b34450f26094f049a9b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Atrium Health Carolinas Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1000 Blythe Blvd, Charlotte, NC 28203, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-be38-70fb-a71f-02ab2190a4e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-be38-70fb-a71f-02ab2190a4e3",
        "storage_key": "property/5690269169090560/019f14f0-be38-70fb-a71f-02ab2190a4e3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://atriumhealth.org/locations/detail/carolinas-medical-center?utm_source=GMB&utm_medium=Organic&utm_campaign=GCR",
      "poi_directions_map_url": "https://maps.google.com/?cid=15333130286636265397&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atrium-health-carolinas-medical-center",
      "poi_latitude": "35.2037121",
      "poi_longitude": "-80.83882260000001",
      "poi_miles_from_property": "11.7 mi",
      "poi_walking_minutes": "4 hours 19 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 704-355-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bcb4-70ee-b8b7-82cb724336d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bcb4-70ee-b8b7-82cb724336d8",
        "storage_key": "property/5690269169090560/019f14eb-bcb4-70ee-b8b7-82cb724336d8.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJtwD7bJGfVogRte-83cE4ytQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "ec_196d86bbe570a951c662b70f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Novant Health Presbyterian Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "200 Hawthorne Ln, Charlotte, NC 28204, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-bea0-72be-b001-5493c8b1428e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-bea0-72be-b001-5493c8b1428e",
        "storage_key": "property/5690269169090560/019f14f0-bea0-72be-b001-5493c8b1428e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.novanthealth.org/locations/medical-centers/presbyterian-medical-center/?utm_source=maps.google.com&utm_medium=organic&utm_campaign=GBP&utm_content=MC-11",
      "poi_directions_map_url": "https://maps.google.com/?cid=10965927297486108609&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "novant-health-presbyterian-medical-center",
      "poi_latitude": "35.2117536",
      "poi_longitude": "-80.8244434",
      "poi_miles_from_property": "11.4 mi",
      "poi_walking_minutes": "4 hours 17 mins",
      "poi_biking_minutes": "1 hour 11 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 704-384-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bcb4-70ee-b8b7-82cb724336d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bcb4-70ee-b8b7-82cb724336d8",
        "storage_key": "property/5690269169090560/019f14eb-bcb4-70ee-b8b7-82cb724336d8.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJMUij1PafVogRwTdr78bMLpg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "ec_9875f0cb298befb244dfd4ac",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Bank of America Corporate Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 N Tryon St, Charlotte, NC 28202, USA",
      "poi_short_description": "Part of a chain, this financial institution offers services like accounts, credit cards, and deposits.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-c6d4-7239-bfac-53f5b5a7b112.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-c6d4-7239-bfac-53f5b5a7b112",
        "storage_key": "property/5690269169090560/019f14f0-c6d4-7239-bfac-53f5b5a7b112.webp",
        "width": 721,
        "height": 1280
      },
      "poi_business_url": "https://www.bankofamerica.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6278332633274031391&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bank-of-america-corporate-center",
      "poi_latitude": "35.2275159",
      "poi_longitude": "-80.8421672",
      "poi_miles_from_property": "9.7 mi",
      "poi_walking_minutes": "3 hours 37 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 800-432-1002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bc97-715e-965b-a20400c4c50d",
        "storage_key": "property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ3DKDCWgVogRH50KFEQeIVc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "finance"
    },
    {
      "id": "ec_e8156296e9115193bba54e07",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Duke Energy",
      "poi_type": "Major Employers & Offices",
      "poi_address": "525 S Tryon St, Charlotte, NC 28202, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-c7ff-768d-9405-c07b949519fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-c7ff-768d-9405-c07b949519fb",
        "storage_key": "property/5690269169090560/019f14f0-c7ff-768d-9405-c07b949519fb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.duke-energy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3821899997112668324&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "duke-energy",
      "poi_latitude": "35.2236874",
      "poi_longitude": "-80.84766309999999",
      "poi_miles_from_property": "10.2 mi",
      "poi_walking_minutes": "3 hours 47 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 800-774-1226",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bc97-715e-965b-a20400c4c50d",
        "storage_key": "property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeckepVqhVogRpJD3TswdCjU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_3eb1f041e397b8f92f9c3ac3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "One Wells Fargo Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "One Wells Fargo Center, 301 S College St #3500, Charlotte, NC 28202, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-cf22-766e-9616-259822c8eb34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-cf22-766e-9616-259822c8eb34",
        "storage_key": "property/5690269169090560/019f14f0-cf22-766e-9616-259822c8eb34.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15467978980228874379&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "one-wells-fargo-center",
      "poi_latitude": "35.223977",
      "poi_longitude": "-80.844668",
      "poi_miles_from_property": "10.0 mi",
      "poi_walking_minutes": "3 hours 43 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bc97-715e-965b-a20400c4c50d",
        "storage_key": "property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrYELFgChVogRi0DA_e1MqdY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_e040b80eaf50f840efe95fbe",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Charlotte Douglas International Airport",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5501 Josh Birmingham Pkwy, Charlotte, NC 28208, USA",
      "poi_short_description": "Airport with rocking chairs, free WiFi & a 60-foot outdoor sculpture symbolizing flight.",
      "poi_long_description": "Airport with rocking chairs, free WiFi & a 60-foot outdoor sculpture symbolizing flight.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-b7ef-717f-9d62-8310df8de321.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-b7ef-717f-9d62-8310df8de321",
        "storage_key": "property/5690269169090560/019f14f0-b7ef-717f-9d62-8310df8de321.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cltairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1925933632275654455&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charlotte-douglas-international-airport",
      "poi_latitude": "35.2162994",
      "poi_longitude": "-80.95394280000001",
      "poi_miles_from_property": "17.0 mi",
      "poi_walking_minutes": "6 hours 16 mins",
      "poi_biking_minutes": "1 hour 44 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 704-359-4013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-e5ac-727f-bc66-a0ec7860697d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e5ac-727f-bc66-a0ec7860697d",
        "storage_key": "property/5690269169090560/019f14f0-e5ac-727f-bc66-a0ec7860697d.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJidRKt32YVogRN6fEPG9Kuho",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_b497b14655422c4d658f1ae0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Charlotte-Mecklenburg Government Center (CMGC)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "600 E 4th St, Charlotte, NC 28202, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-d090-76ea-add2-5ebd1ad35ac1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-d090-76ea-add2-5ebd1ad35ac1",
        "storage_key": "property/5690269169090560/019f14f0-d090-76ea-add2-5ebd1ad35ac1.webp",
        "width": 1280,
        "height": 894
      },
      "poi_business_url": "http://charlottenc.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8518659773066606155&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charlotte-mecklenburg-government-center-cmgc",
      "poi_latitude": "35.2216474",
      "poi_longitude": "-80.8393449",
      "poi_miles_from_property": "10.2 mi",
      "poi_walking_minutes": "3 hours 49 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 704-336-7600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-e5a5-736a-adca-bcb528f8154a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14f0-e5a5-736a-adca-bcb528f8154a",
        "storage_key": "property/5690269169090560/019f14f0-e5a5-736a-adca-bcb528f8154a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy9MQ3CagVogRS3YLCO5bOHY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "ec_cf476308486a523e55c27cd6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "Truist Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "214 N Tryon St, Charlotte, NC 28202, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14f0-d72d-7489-b20e-f1b95b9b800e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14f0-d72d-7489-b20e-f1b95b9b800e",
        "storage_key": "property/5690269169090560/019f14f0-d72d-7489-b20e-f1b95b9b800e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.truist.com/branch/nc/charlotte/28202/214-n-tryon-st-ste-3",
      "poi_directions_map_url": "https://maps.google.com/?cid=12412407560634313315&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "truist-center",
      "poi_latitude": "35.22824689999999",
      "poi_longitude": "-80.8413663",
      "poi_miles_from_property": "9.7 mi",
      "poi_walking_minutes": "3 hours 37 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 704-625-5821",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bc97-715e-965b-a20400c4c50d",
        "storage_key": "property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQVLqFyWgVogRYyr7oum6Qaw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_334baf5b35c60997261619cf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "generator",
      "poi_name": "University Research Park",
      "poi_type": "Major Employers & Offices",
      "poi_address": "David Taylor Dr &, Andrew Carnegie Blvd, Charlotte, NC 28262, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=6219936161875630100&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-research-park",
      "poi_latitude": "35.321521",
      "poi_longitude": "-80.755825",
      "poi_miles_from_property": "9.9 mi",
      "poi_walking_minutes": "3 hours 37 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14eb-bc97-715e-965b-a20400c4c50d",
        "storage_key": "property/5690269169090560/019f14eb-bc97-715e-965b-a20400c4c50d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlwUdBogdVIgRFBg0DvymUVY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "custom_72147b53-d917-42d2-900b-e5e33efea81f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_fc48cae3-4cd4-482a-9d6f-6345c9ba6a1c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_50bf2a3b-b563-44ee-8368-ae9dc826adf2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_0490def7-9580-45c6-85cc-4c86d8f717de",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_6ae03d6a-f13a-454b-b475-f8e7657b0789",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_d6af786c-401e-4dd2-a532-a0ea912ac558",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_15837d6dbfca1b263214bd57",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "rating": "5",
      "name": "cory talbert",
      "text": "The total experience from the beginning has been a true God send!!! The staff is so nice and attentive, the best leasing staff I have ever encountered. The apartment was clean and everything worked the neighborhood is quiet there’s normal kid activity but nothing over the top. The maintenance staff responds almost immediately and completes the repairs quickly and efficiently and they are also extremely nice and thorough they explain everything. The price is soooo reasonable and they have an overload of amenities including valet trash pick up from your door and an internet/cable package that’s includes most of the top movie and tv apps!!! I totally recommend\n#iloveithere",
      "date": "2026-04-15",
      "title": "false"
    },
    {
      "id": "ec_78625d120c761676d0d4c5ec",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "rating": "5",
      "name": "Melissa Hill",
      "text": "The move in at The Murray was really simple and easy. Breanna responded promptly to all my questions and even worked with me when I had to change my move in date. The apartment was pretty clean upon move in and they left me a move in gift. Maintenance responded to my requests within 24hours. I really enjoy the app they use to control the locks, thermostat and lights. The neighborhood is fairly quiet. In the evening I have noticed some young men hanging around the mailbox multiple nights in a row. But other than that no complaints about the property itself. I would recommend.",
      "date": "2026-01-16",
      "title": "false"
    },
    {
      "id": "ec_076830aae9e91cdc4319b4e8",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "rating": "5",
      "name": "kerian walker",
      "text": "From the beginning to my journey up until this point Heather and Carmen have always been so supportive and on my side. They gave my daughter and I an opportunity to have housing again. They are so understanding and transparent and they will work with you in anyway they can. Any issue or call I’ve made they follow up promptly or will even come out themselves to ensure that the task is completed. Overall, for this to be my first time getting an apartment this has been a blessing of an an experience and I hope to continue to be apart of this community.",
      "date": "2025-08-18",
      "title": "false"
    },
    {
      "id": "ec_a7f8dc6915a5080e9b565021",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "rating": "5",
      "name": "Kanyen King",
      "text": "Heather has been very helpful since she has arrived.  She takes care of issues that need to be resolved in a timely manner. The maintenance men, Nick and Henry are amazing as well and always on point. The staff here at the leasing office has been through so much. They all have Outstanding customer service!!! Thank you so much to all of you for caring about improving this community. We appreciate your hard work.",
      "date": "2025-05-16",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_945c0875-7966-41df-9307-9e7039268c00",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14c2-f8ff-76dc-9dd1-3d78a3039bc0.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c2-f8ff-76dc-9dd1-3d78a3039bc0",
        "storage_key": "property/5690269169090560/019f14c2-f8ff-76dc-9dd1-3d78a3039bc0.webp",
        "width": 800,
        "height": 449
      },
      "virtual_tour_title": "2BR, 2BA",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=HBSxKawvufP"
    },
    {
      "id": "custom_a9adb796-66dc-4da0-b54f-4386b7166467",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019d02f1-026f-7774-af55-f2d3787dae56.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Interior view of an empty apartment living room with a ceiling fan and sliding glass door.",
        "public_id": "019d02f1-026f-7774-af55-f2d3787dae56",
        "storage_key": "property/5690269169090560/019d02f1-026f-7774-af55-f2d3787dae56.webp",
        "width": 2048,
        "height": 1152
      },
      "virtual_tour_title": "3BR, 2BA",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=3Ud8mWQg6kV"
    },
    {
      "id": "custom_6736a34e-677f-42c6-b2d2-a6e2ff5dd511",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "YouTube channel: American Landmark",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f14c2-f937-7570-ae51-9a8c63a59392.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c2-f937-7570-ae51-9a8c63a59392",
        "storage_key": "property/5690269169090560/019f14c2-f937-7570-ae51-9a8c63a59392.webp",
        "width": 480,
        "height": 360
      },
      "virtual_tour_title": "The Murray Community Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.youtube.com/embed/SQ5vyRQCNow"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa46-50e4-7658-8e5b-1483d5ef65ca",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "the-murray",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560"
    },
    {
      "lead_collector_id": "0198aa46-5147-7311-a32f-1b422f02e6cf",
      "lead_source": "FACEBOOK_ADS",
      "name": "the-murray",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560"
    },
    {
      "lead_collector_id": "0198aa46-51aa-76e1-9217-89dc735adecd",
      "lead_source": "LANDING_PAGE",
      "name": "the-murray",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "custom",
      "page_item_url": "discover-two-bedrooms-apartments-for-rent-charlotte-nc",
      "search_query": "Two Bedrooms Apartments For Rent In Charlotte NC",
      "category": "Floorplan",
      "h1_title": "Discover Two Bedrooms Apartments For Rent In Charlotte NC",
      "h2_subtitle": "The Murray offers spacious two-bedroom apartments with modern amenities. Enjoy convenient access to Northlake Mall and major highways for easy commuting.",
      "page_copy": "Welcome to The Murray, where our two-bedroom apartments for rent in Charlotte, NC, provide the perfect blend of comfort and convenience. Located near Interstate 77 and across from Northlake Mall, our community ensures you're never far from shopping, dining, and entertainment. Each apartment features high-speed internet access, washer/dryer hookups, and stainless steel appliances, making daily life a breeze. Enjoy cooking in a kitchen with quartz countertops and relax in a living space with vaulted ceilings and a private balcony. At The Murray, you'll find everything you need to feel at home, including a 24-hour fitness center and a playground for the little ones. Experience the best of Charlotte living with our exceptional apartment features and prime location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f6c13-5265-720b-b40d-47f1e2601602.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool area with lounge chairs and a table with umbrella.",
        "public_id": "019f6c13-5265-720b-b40d-47f1e2601602",
        "storage_key": "property/5690269169090560/019f6c13-5265-720b-b40d-47f1e2601602.webp",
        "width": 1504,
        "height": 1003
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f6c13-5b71-747a-8be4-5e1e92e49901.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of apartment building",
        "public_id": "019f6c13-5b71-747a-8be4-5e1e92e49901",
        "storage_key": "property/5690269169090560/019f6c13-5b71-747a-8be4-5e1e92e49901.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Murray | Two Bedrooms Apartments For Rent In Charlotte NC",
      "seo_description": "Explore The Murray's two bedrooms apartments for rent in Charlotte, NC. Enjoy modern amenities and a prime location near Northlake Mall and major highways.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "custom",
      "page_item_url": "spacious-three-bedrooms-apartments-for-rent-charlotte-nc",
      "search_query": "Three Bedrooms Apartments For Rent In Charlotte NC",
      "category": "Floorplan",
      "h1_title": "Spacious Three Bedrooms Apartments For Rent In Charlotte NC",
      "h2_subtitle": "Experience the comfort of three-bedroom living at The Murray. Our prime location and modern amenities make it the perfect choice for families and roommates.",
      "page_copy": "The Murray offers three bedrooms apartments for rent in Charlotte, NC, designed to meet the needs of families and roommates alike. Situated near Interstate 77 and across from Northlake Mall, our community provides easy access to shopping, dining, and entertainment. Each apartment features high-speed internet access, washer/dryer hookups, and stainless steel appliances, ensuring a modern living experience. Enjoy preparing meals in a kitchen with quartz countertops and unwind in a spacious living area with vaulted ceilings and a private balcony. Our community amenities, including a 24-hour fitness center and playground, enhance your lifestyle, making The Murray an ideal place to call home. Discover the perfect blend of convenience and comfort in our three-bedroom apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f6c13-5265-720b-b40d-47f1e2601602.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool area with lounge chairs and a table with umbrella.",
        "public_id": "019f6c13-5265-720b-b40d-47f1e2601602",
        "storage_key": "property/5690269169090560/019f6c13-5265-720b-b40d-47f1e2601602.webp",
        "width": 1504,
        "height": 1003
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f6c13-5b71-747a-8be4-5e1e92e49901.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of apartment building",
        "public_id": "019f6c13-5b71-747a-8be4-5e1e92e49901",
        "storage_key": "property/5690269169090560/019f6c13-5b71-747a-8be4-5e1e92e49901.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Murray | Three Bedrooms Apartments For Rent In Charlotte NC",
      "seo_description": "Find three bedrooms apartments for rent in Charlotte, NC at The Murray. Enjoy modern amenities and a convenient location near Northlake Mall and major highways.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-near-me-with-pool",
      "search_query": "Apartments For Rent Near Me with Pool",
      "category": "Amenity",
      "h1_title": "Find Apartments For Rent Near Me with Pool at The Murray",
      "h2_subtitle": "The Murray offers exceptional apartments with a pool and more. Enjoy a convenient location near Northlake Mall and major highways for easy access to everything.",
      "page_copy": "Discover The Murray, where apartments for rent near me with pool offer a perfect blend of luxury and convenience. Located near Interstate 77 and across from Northlake Mall, our community provides easy access to shopping, dining, and entertainment. Our residents enjoy a refreshing pool, a 24-hour fitness center, and a pet play area, making it an ideal choice for active lifestyles. Each apartment features modern amenities, including hardwood-style flooring and a complete kitchen appliance package, ensuring a comfortable living experience. With available two and three-bedroom floor plans, The Murray caters to various needs, providing a welcoming environment for all. Experience the best of Charlotte living with our exceptional community amenities and prime location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f6c13-5265-720b-b40d-47f1e2601602.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool area with lounge chairs and a table with umbrella.",
        "public_id": "019f6c13-5265-720b-b40d-47f1e2601602",
        "storage_key": "property/5690269169090560/019f6c13-5265-720b-b40d-47f1e2601602.webp",
        "width": 1504,
        "height": 1003
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f6c13-5b71-747a-8be4-5e1e92e49901.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of apartment building",
        "public_id": "019f6c13-5b71-747a-8be4-5e1e92e49901",
        "storage_key": "property/5690269169090560/019f6c13-5b71-747a-8be4-5e1e92e49901.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Murray | Apartments For Rent Near Me with Pool",
      "seo_description": "Explore apartments for rent near me with pool at The Murray. Enjoy modern amenities and a prime location near Northlake Mall and major highways.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-me-with-fitness-center",
      "search_query": "Apartments For Rent Near Me with Fitness Center",
      "category": "Amenity",
      "h1_title": "Discover Apartments For Rent Near Me with Fitness Center at The Murray",
      "h2_subtitle": "The Murray offers modern apartments with a 24-hour fitness center. Enjoy a prime location near Northlake Mall and easy access to major highways.",
      "page_copy": "Welcome to The Murray, where apartments for rent near me with fitness center provide the perfect setting for an active lifestyle. Ideally located near Interstate 77 and across from Northlake Mall, our community offers convenient access to shopping, dining, and entertainment. Residents can take advantage of our 24-hour fitness center, ensuring you can work out on your schedule. Our apartments feature hardwood-style flooring and a complete kitchen appliance package, creating a comfortable and stylish living environment. With two and three-bedroom floor plans available, The Murray caters to diverse needs, making it an ideal choice for families and individuals alike. Experience the best of Charlotte living with our exceptional amenities and convenient location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f6c13-5265-720b-b40d-47f1e2601602.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool area with lounge chairs and a table with umbrella.",
        "public_id": "019f6c13-5265-720b-b40d-47f1e2601602",
        "storage_key": "property/5690269169090560/019f6c13-5265-720b-b40d-47f1e2601602.webp",
        "width": 1504,
        "height": 1003
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f6c13-5b71-747a-8be4-5e1e92e49901.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of apartment building",
        "public_id": "019f6c13-5b71-747a-8be4-5e1e92e49901",
        "storage_key": "property/5690269169090560/019f6c13-5b71-747a-8be4-5e1e92e49901.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Murray | Apartments For Rent Near Me with Fitness Center",
      "seo_description": "Find apartments for rent near me with fitness center at The Murray. Enjoy modern amenities and a prime location near Northlake Mall and major highways.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "custom",
      "page_item_url": "explore-apartments-for-rent-near-me-with-pet-play-area",
      "search_query": "Apartments For Rent Near Me with Pet Play Area",
      "category": "Amenity",
      "h1_title": "Explore Apartments For Rent Near Me with Pet Play Area at The Murray",
      "h2_subtitle": "The Murray offers pet-friendly apartments with a dedicated pet play area. Enjoy a convenient location near Northlake Mall and major highways.",
      "page_copy": "Welcome to The Murray, where apartments for rent near me with pet play area cater to both you and your furry friends. Conveniently located near Interstate 77 and across from Northlake Mall, our community provides easy access to shopping, dining, and entertainment. Our pet-friendly environment includes a dedicated pet play area, ensuring your pets have a space to enjoy. Each apartment features hardwood-style flooring and a complete kitchen appliance package, offering a comfortable and modern living experience. With two and three-bedroom floor plans available, The Murray is perfect for families and pet owners alike. Experience the best of Charlotte living with our exceptional amenities and prime location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f6c13-5265-720b-b40d-47f1e2601602.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool area with lounge chairs and a table with umbrella.",
        "public_id": "019f6c13-5265-720b-b40d-47f1e2601602",
        "storage_key": "property/5690269169090560/019f6c13-5265-720b-b40d-47f1e2601602.webp",
        "width": 1504,
        "height": 1003
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f6c13-5b71-747a-8be4-5e1e92e49901.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of apartment building",
        "public_id": "019f6c13-5b71-747a-8be4-5e1e92e49901",
        "storage_key": "property/5690269169090560/019f6c13-5b71-747a-8be4-5e1e92e49901.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Murray | Apartments For Rent Near Me with Pet Play Area",
      "seo_description": "Discover apartments for rent near me with pet play area at The Murray. Enjoy modern amenities and a prime location near Northlake Mall and major highways.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-near-me-ev-charging-murray",
      "search_query": "Apartments For Rent Near Me with EV Charging",
      "category": "Amenity",
      "h1_title": "Find Apartments For Rent Near Me with EV Charging at The Murray",
      "h2_subtitle": "The Murray offers eco-friendly apartments with EV charging stations. Enjoy a prime location near Northlake Mall and easy access to major highways.",
      "page_copy": "Discover The Murray, where apartments for rent near me with EV charging cater to eco-conscious residents. Ideally located near Interstate 77 and across from Northlake Mall, our community provides convenient access to shopping, dining, and entertainment. Our EV charging stations make it easy for electric vehicle owners to stay powered up. Each apartment features hardwood-style flooring and a complete kitchen appliance package, ensuring a modern and comfortable living experience. With two and three-bedroom floor plans available, The Murray is perfect for families and individuals seeking a sustainable lifestyle. Experience the best of Charlotte living with our exceptional amenities and convenient location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f6c13-5265-720b-b40d-47f1e2601602.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool area with lounge chairs and a table with umbrella.",
        "public_id": "019f6c13-5265-720b-b40d-47f1e2601602",
        "storage_key": "property/5690269169090560/019f6c13-5265-720b-b40d-47f1e2601602.webp",
        "width": 1504,
        "height": 1003
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f6c13-5b71-747a-8be4-5e1e92e49901.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of apartment building",
        "public_id": "019f6c13-5b71-747a-8be4-5e1e92e49901",
        "storage_key": "property/5690269169090560/019f6c13-5b71-747a-8be4-5e1e92e49901.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Murray | Apartments For Rent Near Me with EV Charging",
      "seo_description": "Explore apartments for rent near me with EV charging at The Murray. Enjoy modern amenities and a prime location near Northlake Mall and major highways.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-me-with-playground",
      "search_query": "Apartments For Rent Near Me with Playground",
      "category": "Amenity",
      "h1_title": "Discover Apartments For Rent Near Me with Playground at The Murray",
      "h2_subtitle": "The Murray offers family-friendly apartments with a playground. Enjoy a convenient location near Northlake Mall and major highways for easy access.",
      "page_copy": "Welcome to The Murray, where apartments for rent near me with playground provide a perfect setting for families. Conveniently located near Interstate 77 and across from Northlake Mall, our community offers easy access to shopping, dining, and entertainment. Our on-site playground ensures children have a safe and fun place to play. Each apartment features hardwood-style flooring and a complete kitchen appliance package, creating a comfortable and modern living environment. With two and three-bedroom floor plans available, The Murray caters to families of all sizes. Experience the best of Charlotte living with our exceptional amenities and prime location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f6c13-5265-720b-b40d-47f1e2601602.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool area with lounge chairs and a table with umbrella.",
        "public_id": "019f6c13-5265-720b-b40d-47f1e2601602",
        "storage_key": "property/5690269169090560/019f6c13-5265-720b-b40d-47f1e2601602.webp",
        "width": 1504,
        "height": 1003
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f6c13-5b71-747a-8be4-5e1e92e49901.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of apartment building",
        "public_id": "019f6c13-5b71-747a-8be4-5e1e92e49901",
        "storage_key": "property/5690269169090560/019f6c13-5b71-747a-8be4-5e1e92e49901.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Murray | Apartments For Rent Near Me with Playground",
      "seo_description": "Find apartments for rent near me with playground at The Murray. Enjoy modern amenities and a prime location near Northlake Mall and major highways.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "custom",
      "page_item_url": "explore-apartments-for-rent-near-me-with-kitchen",
      "search_query": "Apartments For Rent Near Me with Luxury Kitchen",
      "category": "Amenity",
      "h1_title": "Explore Apartments For Rent Near Me with Luxury Kitchen at The Murray",
      "h2_subtitle": "The Murray offers modern apartments with fully equipped kitchens. Enjoy a prime location near Northlake Mall and easy access to major highways.",
      "page_copy": "Welcome to The Murray, where apartments for rent near me with kitchen provide a perfect blend of style and functionality. Ideally located near Interstate 77 and across from Northlake Mall, our community offers convenient access to shopping, dining, and entertainment. Each apartment features a fully equipped kitchen with stainless steel appliances and quartz countertops, making meal preparation a delight. Enjoy the convenience of washer/dryer hookups and high-speed internet access in your home. With two and three-bedroom floor plans available, The Murray caters to diverse needs, ensuring a comfortable living experience for all. Experience the best of Charlotte living with our exceptional apartment features and prime location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f6c13-5265-720b-b40d-47f1e2601602.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool area with lounge chairs and a table with umbrella.",
        "public_id": "019f6c13-5265-720b-b40d-47f1e2601602",
        "storage_key": "property/5690269169090560/019f6c13-5265-720b-b40d-47f1e2601602.webp",
        "width": 1504,
        "height": 1003
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f6c13-5b71-747a-8be4-5e1e92e49901.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of apartment building",
        "public_id": "019f6c13-5b71-747a-8be4-5e1e92e49901",
        "storage_key": "property/5690269169090560/019f6c13-5b71-747a-8be4-5e1e92e49901.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Murray | Apartments For Rent Near Me with Luxury Kitchen",
      "seo_description": "Discover apartments for rent with a luxury kitchen at The Murray. Enjoy modern amenities and a prime location near Northlake Mall and major highways.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-near-me-stainless-steel",
      "search_query": "Apartments For Rent Near Me with Stainless Steel Appliances",
      "category": "Amenity",
      "h1_title": "Find Apartments For Rent Near Me with Stainless Steel Appliances at The Murray",
      "h2_subtitle": "The Murray offers stylish apartments with stainless steel appliances. Enjoy a convenient location near Northlake Mall and major highways for easy access.",
      "page_copy": "Welcome to The Murray, where apartments for rent near me with stainless steel appliances offer a modern and sleek living experience. Conveniently located near Interstate 77 and across from Northlake Mall, our community provides easy access to shopping, dining, and entertainment. Each apartment features a kitchen equipped with stainless steel appliances and quartz countertops, perfect for culinary enthusiasts. Enjoy the added convenience of washer/dryer hookups and high-speed internet access in your home. With two and three-bedroom floor plans available, The Murray caters to a variety of lifestyles, ensuring a comfortable and stylish living environment. Experience the best of Charlotte living with our exceptional apartment features and prime location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f6c13-5265-720b-b40d-47f1e2601602.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool area with lounge chairs and a table with umbrella.",
        "public_id": "019f6c13-5265-720b-b40d-47f1e2601602",
        "storage_key": "property/5690269169090560/019f6c13-5265-720b-b40d-47f1e2601602.webp",
        "width": 1504,
        "height": 1003
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f6c13-5b71-747a-8be4-5e1e92e49901.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of apartment building",
        "public_id": "019f6c13-5b71-747a-8be4-5e1e92e49901",
        "storage_key": "property/5690269169090560/019f6c13-5b71-747a-8be4-5e1e92e49901.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Murray | Apartments For Rent Near Me with Stainless Steel Appliances",
      "seo_description": "Explore apartments for rent near me with stainless steel appliances at The Murray. Enjoy modern amenities and a prime location near Northlake Mall and major highways.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-near-me-quartz-countertops",
      "search_query": "Apartments For Rent Near Me with Quartz Countertops",
      "category": "Amenity",
      "h1_title": "Discover Apartments For Rent Near Me with Quartz Countertops at The Murray",
      "h2_subtitle": "The Murray offers elegant apartments with quartz countertops. Enjoy a prime location near Northlake Mall and easy access to major highways.",
      "page_copy": "Welcome to The Murray, where apartments for rent near me with quartz countertops provide a touch of elegance and sophistication. Ideally located near Interstate 77 and across from Northlake Mall, our community offers convenient access to shopping, dining, and entertainment. Each apartment features a modern kitchen with quartz countertops and stainless steel appliances, perfect for those who love to cook and entertain. Enjoy the convenience of washer/dryer hookups and high-speed internet access in your home. With two and three-bedroom floor plans available, The Murray caters to diverse needs, ensuring a comfortable and stylish living experience. Experience the best of Charlotte living with our exceptional apartment features and prime location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f6c13-5265-720b-b40d-47f1e2601602.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool area with lounge chairs and a table with umbrella.",
        "public_id": "019f6c13-5265-720b-b40d-47f1e2601602",
        "storage_key": "property/5690269169090560/019f6c13-5265-720b-b40d-47f1e2601602.webp",
        "width": 1504,
        "height": 1003
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f6c13-5b71-747a-8be4-5e1e92e49901.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of apartment building",
        "public_id": "019f6c13-5b71-747a-8be4-5e1e92e49901",
        "storage_key": "property/5690269169090560/019f6c13-5b71-747a-8be4-5e1e92e49901.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Murray | Apartments For Rent Near Me with Quartz Countertops",
      "seo_description": "Find apartments for rent near me with quartz countertops at The Murray. Enjoy modern amenities and a prime location near Northlake Mall and major highways.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "custom",
      "page_item_url": "explore-apartments-for-rent-near-me-with-washer-dryer",
      "search_query": "Apartments For Rent Near Me with Washer/Dryer Hookup",
      "category": "Amenity",
      "h1_title": "Explore Apartments For Rent Near Me with Washer/Dryer Hookup at The Murray",
      "h2_subtitle": "The Murray offers convenient apartments with washer/dryer hookups. Enjoy a prime location near Northlake Mall and easy access to major highways.",
      "page_copy": "Welcome to The Murray, where apartments for rent near me with washer/dryer hookup provide the ultimate convenience for modern living. Ideally located near Interstate 77 and across from Northlake Mall, our community offers easy access to shopping, dining, and entertainment. Each apartment is equipped with washer/dryer hookups, making laundry day a breeze. Enjoy a modern kitchen with stainless steel appliances and quartz countertops, perfect for culinary enthusiasts. With two and three-bedroom floor plans available, The Murray caters to a variety of lifestyles, ensuring a comfortable and stylish living environment. Experience the best of Charlotte living with our exceptional apartment features and prime location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f6c13-5265-720b-b40d-47f1e2601602.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool area with lounge chairs and a table with umbrella.",
        "public_id": "019f6c13-5265-720b-b40d-47f1e2601602",
        "storage_key": "property/5690269169090560/019f6c13-5265-720b-b40d-47f1e2601602.webp",
        "width": 1504,
        "height": 1003
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f6c13-5b71-747a-8be4-5e1e92e49901.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of apartment building",
        "public_id": "019f6c13-5b71-747a-8be4-5e1e92e49901",
        "storage_key": "property/5690269169090560/019f6c13-5b71-747a-8be4-5e1e92e49901.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Murray | Apartments For Rent Near Me with Washer/Dryer Hookup",
      "seo_description": "Discover apartments for rent near me with washer/dryer hookup at The Murray. Enjoy modern amenities and a prime location near Northlake Mall and major highways.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "custom",
      "page_item_url": "find-apartments-for-rent-near-me-with-high-speed-internet",
      "search_query": "Apartments For Rent Near Me with High Speed Internet Access",
      "category": "Amenity",
      "h1_title": "Find Apartments For Rent Near Me with High Speed Internet Access at The Murray",
      "h2_subtitle": "The Murray offers modern apartments with high speed internet access. Enjoy a prime location near Northlake Mall and easy access to major highways.",
      "page_copy": "Welcome to The Murray, where apartments for rent near me with high speed internet access ensure you stay connected at all times. Conveniently located near Interstate 77 and across from Northlake Mall, our community provides easy access to shopping, dining, and entertainment. Each apartment is equipped with high speed internet access, making it ideal for remote work or streaming your favorite shows. Enjoy a modern kitchen with stainless steel appliances and quartz countertops, perfect for culinary enthusiasts. With two and three-bedroom floor plans available, The Murray caters to a variety of lifestyles, ensuring a comfortable and stylish living environment. Experience the best of Charlotte living with our exceptional apartment features and prime location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f6c13-5265-720b-b40d-47f1e2601602.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool area with lounge chairs and a table with umbrella.",
        "public_id": "019f6c13-5265-720b-b40d-47f1e2601602",
        "storage_key": "property/5690269169090560/019f6c13-5265-720b-b40d-47f1e2601602.webp",
        "width": 1504,
        "height": 1003
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f6c13-5b71-747a-8be4-5e1e92e49901.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of apartment building",
        "public_id": "019f6c13-5b71-747a-8be4-5e1e92e49901",
        "storage_key": "property/5690269169090560/019f6c13-5b71-747a-8be4-5e1e92e49901.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Murray | Apartments For Rent Near Me with High Speed Internet Access",
      "seo_description": "Explore apartments for rent near me with high speed internet access at The Murray. Enjoy modern amenities and a prime location near Northlake Mall and major highways.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-charlotte-nc-near-fresenius-medical-care",
      "search_query": "Apartments For Rent In Charlotte NC Near Fresenius Medical Care ",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Charlotte NC Near Fresenius Medical Care ",
      "h2_subtitle": "The Murray offers convenient living near Fresenius Medical Care at Cmc University. Enjoy modern amenities and a prime location for easy access to healthcare and more.",
      "page_copy": "Welcome to The Murray, where apartments for rent in Charlotte, NC, are conveniently located near Fresenius Medical Care at Cmc University. Our community provides easy access to healthcare facilities, making it an ideal choice for medical professionals and patients alike. Situated near Interstate 77 and across from Northlake Mall, The Murray offers a prime location for shopping, dining, and entertainment. Each apartment features modern amenities, including high-speed internet access, stainless steel appliances, and quartz countertops, ensuring a comfortable and stylish living experience. With two and three-bedroom floor plans available, The Murray caters to diverse needs, providing a welcoming environment for all. Experience the best of Charlotte living with our exceptional apartment features and convenient location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f6c13-5265-720b-b40d-47f1e2601602.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool area with lounge chairs and a table with umbrella.",
        "public_id": "019f6c13-5265-720b-b40d-47f1e2601602",
        "storage_key": "property/5690269169090560/019f6c13-5265-720b-b40d-47f1e2601602.webp",
        "width": 1504,
        "height": 1003
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f6c13-5b71-747a-8be4-5e1e92e49901.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of apartment building",
        "public_id": "019f6c13-5b71-747a-8be4-5e1e92e49901",
        "storage_key": "property/5690269169090560/019f6c13-5b71-747a-8be4-5e1e92e49901.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Murray | Apartments For Rent In Charlotte NC Near Fresenius Medical Care",
      "seo_description": "Find apartments for rent in Charlotte, NC near Fresenius Medical Care at Cmc University at The Murray. Enjoy modern amenities and a prime location for easy access.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "custom",
      "page_item_url": "explore-apartments-for-rent-charlotte-nc-near-novant-health",
      "search_query": "Apartments For Rent In Charlotte NC Near Novant Health Huntersville Medical Center",
      "category": "POI",
      "h1_title": "Explore Apartments For Rent In Charlotte NC Near Novant Health Huntersville Medical Center",
      "h2_subtitle": "The Murray offers convenient living near Novant Health Huntersville Medical Center. Enjoy modern amenities and a prime location for easy access to healthcare and more.",
      "page_copy": "Welcome to The Murray, where apartments for rent in Charlotte, NC, are ideally located near Novant Health Huntersville Medical Center. Our community provides easy access to healthcare facilities, making it an excellent choice for medical professionals and patients. Situated near Interstate 77 and across from Northlake Mall, The Murray offers a prime location for shopping, dining, and entertainment. Each apartment features modern amenities, including high-speed internet access, stainless steel appliances, and quartz countertops, ensuring a comfortable and stylish living experience. With two and three-bedroom floor plans available, The Murray caters to diverse needs, providing a welcoming environment for all. Experience the best of Charlotte living with our exceptional apartment features and convenient location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f6c13-5265-720b-b40d-47f1e2601602.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool area with lounge chairs and a table with umbrella.",
        "public_id": "019f6c13-5265-720b-b40d-47f1e2601602",
        "storage_key": "property/5690269169090560/019f6c13-5265-720b-b40d-47f1e2601602.webp",
        "width": 1504,
        "height": 1003
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f6c13-5b71-747a-8be4-5e1e92e49901.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of apartment building",
        "public_id": "019f6c13-5b71-747a-8be4-5e1e92e49901",
        "storage_key": "property/5690269169090560/019f6c13-5b71-747a-8be4-5e1e92e49901.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Murray | Apartments For Rent In Charlotte NC Near Novant Health Huntersville Medical Center",
      "seo_description": "Find apartments for rent in Charlotte, NC near Novant Health Huntersville Medical Center at The Murray. Enjoy modern amenities and a prime location for easy access.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-charlotte-nc-near-atrium-health",
      "search_query": "Apartments For Rent In Charlotte NC Near Atrium Health University City",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Charlotte NC Near Atrium Health University City",
      "h2_subtitle": "The Murray offers convenient living near Atrium Health University City. Enjoy modern amenities and a prime location for easy access to healthcare and more.",
      "page_copy": "Welcome to The Murray, where apartments for rent in Charlotte, NC, are ideally located near Atrium Health University City. Our community provides easy access to a broad range of healthcare services, making it an excellent choice for medical professionals and patients. Situated near Interstate 77 and across from Northlake Mall, The Murray offers a prime location for shopping, dining, and entertainment. Each apartment features modern amenities, including high-speed internet access, stainless steel appliances, and quartz countertops, ensuring a comfortable and stylish living experience. With two and three-bedroom floor plans available, The Murray caters to diverse needs, providing a welcoming environment for all. Experience the best of Charlotte living with our exceptional apartment features and convenient location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f6c13-5265-720b-b40d-47f1e2601602.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool area with lounge chairs and a table with umbrella.",
        "public_id": "019f6c13-5265-720b-b40d-47f1e2601602",
        "storage_key": "property/5690269169090560/019f6c13-5265-720b-b40d-47f1e2601602.webp",
        "width": 1504,
        "height": 1003
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f6c13-5b71-747a-8be4-5e1e92e49901.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of apartment building",
        "public_id": "019f6c13-5b71-747a-8be4-5e1e92e49901",
        "storage_key": "property/5690269169090560/019f6c13-5b71-747a-8be4-5e1e92e49901.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Murray | Apartments For Rent In Charlotte NC Near Atrium Health University City",
      "seo_description": "Find apartments for rent in Charlotte, NC near Atrium Health University City at The Murray. Enjoy modern amenities and a prime location for easy access.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "custom",
      "page_item_url": "explore-apartments-for-rent-charlotte-nc-uncc",
      "search_query": "Apartments For Rent In Charlotte NC Near University of North Carolina at Charlotte",
      "category": "POI",
      "h1_title": "Explore Apartments For Rent In Charlotte NC Near University of North Carolina at Charlotte",
      "h2_subtitle": "The Murray offers convenient living near the University of North Carolina at Charlotte. Enjoy modern amenities and a prime location for easy access to education and more.",
      "page_copy": "Welcome to The Murray, where apartments for rent in Charlotte, NC, are ideally located near the University of North Carolina at Charlotte. Our community provides easy access to educational facilities, making it an excellent choice for students, faculty, and staff. Situated near Interstate 77 and across from Northlake Mall, The Murray offers a prime location for shopping, dining, and entertainment. Each apartment features modern amenities, including high-speed internet access, stainless steel appliances, and quartz countertops, ensuring a comfortable and stylish living experience. With two and three-bedroom floor plans available, The Murray caters to diverse needs, providing a welcoming environment for all. Experience the best of Charlotte living with our exceptional apartment features and convenient location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f6c13-5265-720b-b40d-47f1e2601602.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool area with lounge chairs and a table with umbrella.",
        "public_id": "019f6c13-5265-720b-b40d-47f1e2601602",
        "storage_key": "property/5690269169090560/019f6c13-5265-720b-b40d-47f1e2601602.webp",
        "width": 1504,
        "height": 1003
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f6c13-5b71-747a-8be4-5e1e92e49901.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of apartment building",
        "public_id": "019f6c13-5b71-747a-8be4-5e1e92e49901",
        "storage_key": "property/5690269169090560/019f6c13-5b71-747a-8be4-5e1e92e49901.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Murray | Apartments For Rent In Charlotte NC Near University of North Carolina at Charlotte",
      "seo_description": "Find apartments for rent in Charlotte, NC near University of North Carolina at Charlotte at The Murray. Enjoy modern amenities and a prime location for easy access.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-charlotte-nc-near-belmont-abbey",
      "search_query": "Apartments For Rent In Charlotte NC Near Belmont Abbey College",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Charlotte NC Near Belmont Abbey College",
      "h2_subtitle": "The Murray offers convenient living near Belmont Abbey College. Enjoy modern amenities and a prime location for easy access to education and more.",
      "page_copy": "Welcome to The Murray, where apartments for rent in Charlotte, NC, are ideally located near Belmont Abbey College. Our community provides easy access to educational facilities, making it an excellent choice for students, faculty, and staff. Situated near Interstate 77 and across from Northlake Mall, The Murray offers a prime location for shopping, dining, and entertainment. Each apartment features modern amenities, including high-speed internet access, stainless steel appliances, and quartz countertops, ensuring a comfortable and stylish living experience. With two and three-bedroom floor plans available, The Murray caters to diverse needs, providing a welcoming environment for all. Experience the best of Charlotte living with our exceptional apartment features and convenient location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f6c13-5265-720b-b40d-47f1e2601602.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool area with lounge chairs and a table with umbrella.",
        "public_id": "019f6c13-5265-720b-b40d-47f1e2601602",
        "storage_key": "property/5690269169090560/019f6c13-5265-720b-b40d-47f1e2601602.webp",
        "width": 1504,
        "height": 1003
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f6c13-5b71-747a-8be4-5e1e92e49901.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of apartment building",
        "public_id": "019f6c13-5b71-747a-8be4-5e1e92e49901",
        "storage_key": "property/5690269169090560/019f6c13-5b71-747a-8be4-5e1e92e49901.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Murray | Apartments For Rent In Charlotte NC Near Belmont Abbey College",
      "seo_description": "Find apartments for rent in Charlotte, NC near Belmont Abbey College at The Murray. Enjoy modern amenities and a prime location for easy access.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "custom",
      "page_item_url": "explore-apartments-for-rent-near-wake-forest-university",
      "search_query": "Apartments For Rent Near Wake Forest University School of Business Charlotte campus",
      "category": "POI",
      "h1_title": "Explore Apartments For Rent Near Wake Forest University School of Business Charlotte campus",
      "h2_subtitle": "The Murray offers convenient living near Wake Forest University School of Business Charlotte campus. Enjoy modern amenities and a prime location for easy access to education and more.",
      "page_copy": "Welcome to The Murray, where apartments for rent in Charlotte, NC, are ideally located near Wake Forest University School of Business Charlotte campus. Our community provides easy access to educational facilities, making it an excellent choice for students, faculty, and staff. Situated near Interstate 77 and across from Northlake Mall, The Murray offers a prime location for shopping, dining, and entertainment. Each apartment features modern amenities, including high-speed internet access, stainless steel appliances, and quartz countertops, ensuring a comfortable and stylish living experience. With two and three-bedroom floor plans available, The Murray caters to diverse needs, providing a welcoming environment for all. Experience the best of Charlotte living with our exceptional apartment features and convenient location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f6c13-5265-720b-b40d-47f1e2601602.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool area with lounge chairs and a table with umbrella.",
        "public_id": "019f6c13-5265-720b-b40d-47f1e2601602",
        "storage_key": "property/5690269169090560/019f6c13-5265-720b-b40d-47f1e2601602.webp",
        "width": 1504,
        "height": 1003
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f6c13-5b71-747a-8be4-5e1e92e49901.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of apartment building",
        "public_id": "019f6c13-5b71-747a-8be4-5e1e92e49901",
        "storage_key": "property/5690269169090560/019f6c13-5b71-747a-8be4-5e1e92e49901.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Murray | Apartments For Rent Near Wake Forest University School of Business Charlotte campus",
      "seo_description": "Find apartments for rent in Charlotte, NC near Wake Forest University School of Business Charlotte campus at The Murray. Enjoy modern amenities and a prime location for easy access.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5690269169090560",
      "source": "custom",
      "page_item_url": "discover-apartments-for-rent-charlotte-nc-near-cpcc-harris-campus",
      "search_query": "Apartments For Rent In Charlotte NC Near Central Piedmont Community College - Harris Campus",
      "category": "POI",
      "h1_title": "Discover Apartments For Rent In Charlotte NC Near Central Piedmont Community College - Harris Campus",
      "h2_subtitle": "The Murray offers convenient living near Central Piedmont Community College - Harris Campus. Enjoy modern amenities and a prime location for easy access to education and more.",
      "page_copy": "Welcome to The Murray, where apartments for rent in Charlotte, NC, are ideally located near Central Piedmont Community College - Harris Campus. Our community provides easy access to educational facilities, making it an excellent choice for students, faculty, and staff. Situated near Interstate 77 and across from Northlake Mall, The Murray offers a prime location for shopping, dining, and entertainment. Each apartment features modern amenities, including high-speed internet access, stainless steel appliances, and quartz countertops, ensuring a comfortable and stylish living experience. With two and three-bedroom floor plans available, The Murray caters to diverse needs, providing a welcoming environment for all. Experience the best of Charlotte living with our exceptional apartment features and convenient location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f6c13-5265-720b-b40d-47f1e2601602.webp",
      "featured_image_media": {
        "alt_text": "Swimming pool area with lounge chairs and a table with umbrella.",
        "public_id": "019f6c13-5265-720b-b40d-47f1e2601602",
        "storage_key": "property/5690269169090560/019f6c13-5265-720b-b40d-47f1e2601602.webp",
        "width": 1504,
        "height": 1003
      },
      "blank_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5690269169090560/019f6c13-5b71-747a-8be4-5e1e92e49901.webp",
      "blank_image_media": {
        "alt_text": "Exterior view of apartment building",
        "public_id": "019f6c13-5b71-747a-8be4-5e1e92e49901",
        "storage_key": "property/5690269169090560/019f6c13-5b71-747a-8be4-5e1e92e49901.webp",
        "width": 16,
        "height": 16
      },
      "seo_title": "The Murray | Apartments For Rent In Charlotte NC Near Central Piedmont Community College - Harris Campus",
      "seo_description": "Find apartments for rent in Charlotte, NC near Central Piedmont Community College - Harris Campus at The Murray. Enjoy modern amenities and a prime location for easy access.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2601"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "3391673313"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a62\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a62\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5056166"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-M238SR2"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "3"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "9835263912"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "d4a711f15a201272"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/er5v5gg3wny"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/6777addf-de4a-4a58-8f98-bb8d85015425"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "980-525-8728"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Ijl6ZGtBQk51eG1nMzQvbmh2bVZkOEE9PSIsInZhbHVlIjoidUVCTzVSN3NoTkhYOXZ6TWQ3S2Z4dz09IiwibWFjIjoiZjA2NTM4YjNiYzc1ZDM4ZmZiNDU1YjUyMDQyMjAxMDg3ODE0M2JkNjA0YTM4MDZhNDQ4MmU4OGFkMWVkNTg3MSJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2601",
  "custom_repli_id": "3391673313",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a62\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a62\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "5056166",
  "custom_google_gtm_id": "GTM-M238SR2",
  "custom_rollout_phase": "3",
  "custom_ads_subscription": "full_stack",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "9835263912",
  "custom_knock_community_id": "d4a711f15a201272",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/er5v5gg3wny",
  "custom_self_guided_tour_url": "https://selftournow.com/property/6777addf-de4a-4a58-8f98-bb8d85015425",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "980-525-8728",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Ijl6ZGtBQk51eG1nMzQvbmh2bVZkOEE9PSIsInZhbHVlIjoidUVCTzVSN3NoTkhYOXZ6TWQ3S2Z4dz09IiwibWFjIjoiZjA2NTM4YjNiYzc1ZDM4ZmZiNDU1YjUyMDQyMjAxMDg3ODE0M2JkNjA0YTM4MDZhNDQ4MmU4OGFkMWVkNTg3MSJ9",
  "custom_household_income_qualification_multiplier": "3",
  "custom_audioeye_site_id": "8225d182-fea3-4f43-972f-7cdedf53191b",
  "custom_audioeye_site_hash": "7cdd6a54c1000040ad4d437ad3e8fd59"
};

export const generatedAt = '2026-11-03T20:29:04.959Z';
